// #####################################################################################################################
// ############################################## FRAMEWORK JOSCHA START ###############################################
// global scope object cache
// ---------------------------------------------------------------------------------------------------------------------
glob = {};

// ---------------------------------------------------------------------------------------------------------------------
// enable debug messages
glob.enableDebug = true;

// Force this bundle to use a stable jQuery reference even if external scripts altered globals.
var __dbagJq = (function () {
    if (typeof window === 'undefined') {
        return undefined;
    }

    if (window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.on === 'function') {
        return window.jQuery;
    }

    if (window.$ && window.$.fn && typeof window.$.fn.on === 'function') {
        return window.$;
    }

    return window.jQuery || window.$;
})();

var $ = __dbagJq;

// Legacy fallback: add `.on()` support for very old jQuery versions.
if ($ && $.fn && typeof $.fn.on !== 'function' && typeof $.fn.bind === 'function') {
    $.fn.on = function (events, selector, data, handler) {
        if (typeof selector === 'function') {
            return this.bind(events, selector);
        }

        if (typeof data === 'function') {
            handler = data;
        }

        if (typeof selector === 'string' && typeof this.delegate === 'function') {
            return this.delegate(selector, events, handler);
        }

        return this.bind(events, handler);
    };
}

// global settings & vars
// ---------------------------------------------------------------------------------------------------------------------
// jquery animation interval (ms)
glob.html = $('html');
glob.language = glob.html.attr('lang');
glob.doc = $(document);
glob.win = $(window);
glob.winW = glob.win.width();
glob.winH = glob.win.height();
glob.docH = 0;
glob.orientation = Math.abs(window.orientation);
glob.mobileDevice = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
glob.android = (/android/i.test(navigator.userAgent.toLowerCase()));
glob.ios7 = navigator.userAgent.match(/(iPad|iPhone|iPod touch);.*CPU.*OS 7_\d/i);
glob.ios8 = navigator.userAgent.match(/(iPad|iPhone|iPod touch);.*CPU.*OS 8_\d/i);

// global events
// ---------------------------------------------------------------------------------------------------------------------
glob.eventShowElement = 'ELEMENTSHOW';
glob.eventHideElement = 'ELEMENTHIDE';
glob.eventResize = 'WINDOWRESIZE';
glob.eventScroll = 'SCROLLING';
glob.eventFontLoaded = 'FONTLOADED';
glob.eventURLChange = 'URLCHANGE';
glob.eventAjaxLoaded = 'AJAXLOADED';
glob.eventAjaxAfterInit = 'EVENT_AJAX_AFTER_INIT';


// user agent / device settings
// ---------------------------------------------------------------------------------------------------------------------
glob.ie8 = navigator.appVersion.indexOf("MSIE 8") != -1;
glob.ie9 = navigator.appVersion.indexOf("MSIE 9") != -1;
glob.ie10 = navigator.appVersion.indexOf("MSIE 10") != -1;
glob.ie11 = !!window.MSInputMethodContext;
glob.ie = glob.ie9 || glob.ie10 || glob.ie11;
msGesture = window.navigator && window.navigator.msPointerEnabled && window.MSGesture;
//glob.touch = ("ontouchstart" in window) || msGesture || window.DocumentTouch && document instanceof DocumentTouch;
glob.touch = ("ontouchstart" in window) || window.DocumentTouch && document instanceof DocumentTouch;

/**
 * Cleans urls for further usage in webtrekk
 *
 * @param string $url
 * @returns {string}
 */
glob.trackingUrlCleaner = function ($url) {
    var url = $url.toLocaleLowerCase();
    url = url.replace(/https*:\/\//g, '');
    url = url.replace(/(.)\/(.)/g, '$1.$2');
    url = url.replace(/\//g, '');
    url = url.replace(/\s+/g, '-');
    url = url.replace(/&amp;/g, '');

    return url;
};

// debugging helper
// ---------------------------------------------------------------------------------------------------------------------
glob.debug = function ($content) {
    if (!glob.enableDebug) return;
    if (typeof console !== 'object') return;
    if (console.log) console.log($content);
};

$.fn.fastclick = function ($handler, $block) {
    // trigger events only
    if (!$handler) {
        return this.each(function () {
            var link = $(this);
            //glob.debug(link.data('fastclick'));
            if (link.data('fastclick')) {
                var func = link.data('fastclick');
                func();
            }
        });
    }

    if (glob.touch) {
        return this.each(function () {
            var link = $(this);
            var trigger = false;
            var touchStartY = 0;
            var touchStartX = 0;

            link
                .on('touchstart', function ($e) {
                    trigger = true;
                    touchStartY = $e.originalEvent.touches[0].clientY;
                    touchStartX = $e.originalEvent.touches[0].clientX;

                    glob.doc.one(glob.eventScroll, function () {
                        trigger = false;
                    });
                })
                .on('touchend touchcancel', function ($e) {
                    if (!trigger) return true;
                    trigger = false;

                    // map positions to event
                    if (!$e.clientX) {
                        $e.clientX = $e.originalEvent.changedTouches[0].clientX;
                        $e.clientY = $e.originalEvent.changedTouches[0].clientY;
                    }

                    // dont react on touchmove
                    var diffY = Math.abs(touchStartY - $e.clientY);
                    var diffX = Math.abs(touchStartX - $e.clientX);
                    //window.alert('fastclick diff: ' + diffX + ' / ' + diffY);
                    if (diffY > 20 || diffX > 20) return true;

                    var ret = $handler.apply(this, [$e]);
                    return $block ? ret : false;
                })
                .on('click', function ($e) {
                    if (trigger) {
                        return link.triggerHandler('touchend', [$e]);
                    }

                    if ($block) return true;

                    //glob.debug('click');
                    $e.stopImmediatePropagation();
                    return false;
                })
                .data('fastclick', function () {
                    $handler.apply(link[0]);
                });
        });
    }

    return this.each(function () {
        var touchStartY = 0;
        var touchStartX = 0;
        var func = $handler;

        var self = $(this);
        self
            .on('mousedown', function ($e) {
                //app.debug($e);
                touchStartY = $e.clientY;
                touchStartX = $e.clientX;
            })
            .on('click', function ($e) {
                var diffY = Math.abs(touchStartY - $e.clientY);
                var diffX = Math.abs(touchStartX - $e.clientX);
                //app.debug('fastclick diff: ' + diffX + ' / ' + diffY);
                if (!glob.ie && (diffY > 20 || diffX > 20)) return true;

                var ret = $handler.apply(this, [$e]);

                return $block ? ret : false;
            })
            .data('fastclick', function () {
                func.apply(self[0]);
                if (glob.ie9 && self.attr('href')) {
                    window.location.href = self.attr('href');
                }
            });
    });
};
// ############################################## FRAMEWORK JOSCHA ENDE ################################################
// #####################################################################################################################

(function (window, document, $) {


    /**
     * Global variables
     */
    let
        App,
        CanvasMenu,
        Breadcrumb,
        reportStage,
        Glossar,
        globalDownload,
        responsiveTable,
        pdfLink,
        historyBack,
        stickyNavigation,
        equalHeight,
        teamDialog,
        stageVideo,
        newsVideo,
        headerVideo,
        companyMap,
        anchorFix,
        tableFunctions,
        isotopSort,
        newsArchiv,
        socialMedia,
        megaMenu,
        subMenus,
        chartHandler,
        portfolioHack,
        ogb18Scrollto,
        hashDelete,
        languageSwitch,
        searchBar,
        ogbCount,
        naviHideHack,
        naviAnchorHack,
        powermailScrollto,
        totop,
        portfolioSort,
        portfolioCollapse,
        downloadTable,
        ogb19Sidebar,
        goBack,
        hv20,
        CroppingVariants,
        Newsroom,
        NewsroomFilterUrl,
        Audio,
        ogb20,
        Select2,
        phone,
        Disclaimer,
        downloadHoverTextInjection,
        SidebarNavigation,
        PortfolioFacts,
        PortfolioTeaser,
        IndustryDistribution,
        IconSlider,
        FactContentBox,
        PublicationSlider,
        SliderSuccessStories,
        NewsListCarousel,
        applicationForm;

    /**
     * Document Ready Calls
     */
    $(document).ready(function () {
        App.init();
        weCookieConsentChecking();
        //removed CanvasMenu (Mobile Menu) because it is absolutly clutterd with useless code and better to rewrite
        CanvasMenu.init();
        PublicationSlider.init();
        Breadcrumb.init();
        reportStage.init();
        Glossar.init();
        globalDownload.init();
        responsiveTable.init();
        pdfLink.init();
        historyBack.init();
        // stickyNavigation.init();
        equalHeight.init();
        teamDialog.init();
        stageVideo.init();
        newsVideo.init();
        headerVideo.init();
        companyMap.init();
        anchorFix.init();
        tableFunctions.init();
        isotopSort.init();
        //newsArchiv.init();
        socialMedia.init();
        // megaMenu.init();
        chartHandler.init();
        portfolioHack.init();
        hashDelete.init();
        languageSwitch.init();
        searchBar.init();

        //Submenu is no longer needed, that is why I removed the function
        //subMenus.init();
        ogb18Scrollto.init();
        ogb19Sidebar.init();
        ogbCount.init();
        ogb20.init();
        naviHideHack.init();
        naviAnchorHack.init();
        powermailScrollto.init();
        applicationForm.init();
        totop.init();
        portfolioSort.init();
        portfolioCollapse.init()
        downloadTable.init();
        goBack.init();
        hv20.init();
        CroppingVariants.init();
        Newsroom.init();
        NewsroomFilterUrl.init();
        Audio.init();
        Select2.init();
        phone.init();
        downloadHoverTextInjection.init();
        Disclaimer.init();
        SidebarNavigation.init();
        SliderSuccessStories.init();
        FactContentBox.init();
        IndustryDistribution.init();
        PortfolioFacts.init();
        PortfolioTeaser.init();
        IconSlider.init();
        NewsListCarousel.init();

        if ($('.ogb18')[0]) {
            var ScrollPos = $.cookie('scrollPos');
            $(document).scrollTop(ScrollPos || 0)
        }
    });

    /**
     * App: Base application which initializes all other stuff
     * @type {Object}
     */
    App = {
        init: function () {
            // Disable perfectScrollbar on Mobile devices
            if (!glob.mobileDevice) {

                //While making a "rebrush of the site" I updated all JS files. Perfect Scrollbar has changed it't init.
                //Not sure what it does or if it is even working on the old site but to make sure I did't want to delete the old code

                //Update 2
                //However I noticed i dont need it at all, that is why I removed it for now. Otherwise it throws errors because
                //some of the Elements don't even exist on the page.
                //$('.ce-tile .tile.social, .scroll-function').perfectScrollbar({wheelSpeed: 1000});

                //const ps = new PerfectScrollbar('.ce-tile .tile.social, .scroll-function', {
                //     wheelSpeed: 1000
                //});
            }

            //Same as above
            //$('.mega-menu .scroll-wrap, .navigation-block').perfectScrollbar({wheelSpeed: 1000});

            //const ps = new PerfectScrollbar('.mega-menu .scroll-wrap, .navigation-block', {
            //    wheelSpeed: 1000
            //});
            //$().perfectScrollbar({wheelSpeed: 1000});

            // interferes with the mask tab element and is apparently not necessary, so it is commented out
            // $('.nav-tabs').tabCollapse();
            // $('.mask-accordion-list ol').tabCollapse();
        }
    };

    Disclaimer = {
        init: function () {
            const button = $('.submit_disclaimer');
            const capital = $('.submit_disclaimercapital');
            const reject = $('.reject_disclaimercapital');

            $('#country_select_c_residence').change(function () {
                var value = $(this).val();

                var names_arr = ['35', '36', '32', '34'];
                if (names_arr.includes(value)) {
                    $('.country_restriction').css({
                        display: 'none',
                    });
                    $('#Reject').css({
                        display: 'block',
                    });
                }
                else {
                    $('.country_restriction').css({
                        display: 'inline-block',
                    });
                    $('#Reject').css({
                        display: 'none',
                    });

                    capital.click(function (e) {
                        if (($("input[name*='consent']:checked").length) <= 0) {
                            alert("You must fill the fields");
                            e.preventDefault();
                            return false;
                        }


                        var testval = ($('#plz').val());
                        if (!testval) {
                            alert("You must fill the fields");
                            e.preventDefault();
                            return false;
                        }

                        $.cookie('disclaimer', 1);
                        location.reload();

                    });
                }
            });

            reject.click(function () {
                $('#Reject').css({
                    display: 'block',
                });
            });

            button.click(function () {
                $.cookie('disclaimer', 1);
                location.reload();
            });


        }
    }

    Select2 = {
        init: function () {
            $('.yearFilter').select2({
                minimumResultsForSearch: Infinity,
                width: 110,
            });
        }
    };

    phone = {
        init: function () {
            var phone = $('.phone-replace');
            if ($(window).width() > 960) {
                $(phone).click(function (e) {
                    e.preventDefault();
                    var id = $(this).data('phone'),
                        phoneClass = '.phone-' + id;
                    $(phoneClass).removeClass('d-none');
                })
            }

        }
    };

    hv20 = {
        init: function () {
            if ($(window).width() < 960) {
                $('#c2375 .col-lg-9').before($('#c2375 .col-lg-3'))
            }

        }
    };

    Audio = {
        init: function () {
            // Change "{}" to your options:
            // https://github.com/sampotts/plyr/#options
            const player = new Plyr('audio', {});

            // Expose player so it can be used from the console
            window.player = player;
        }
    };

    goBack = {
        init: function () {

            if ($('.ogb18')[0]) {
                $(window).on("scroll", function () {
                    //set scroll position in session storage
                    $.cookie('scrollPos', $(window).scrollTop());
                });
            }
        }
    };

    portfolioSort = {
        init: function () {
            // $('.portfoliio-sort').sort(function (a, b) {
            //     var contentA =parseInt( $(a).attr('data-date'));
            //     var contentB =parseInt( $(b).attr('data-date'));
            //     return (contentA > contentB) ? -1 : (contentA < contentB) ? 1 : 0;
            // });
            $('.list-container').each(function () {
                $(this).find($(".portfolio-sort")).sort(sort_li).appendTo($(this)).find('.list-container');

                function sort_li(a, b) {
                    return ($(b).data('date')) > ($(a).data('date')) ? 1 : -1;
                }
            });

        }
    };

    portfolioCollapse = {
        init: function () {
            var coll = document.getElementsByClassName("portfolio-collapse");
            var i;

            for (i = 0; i < coll.length; i++) {
                coll[i].addEventListener("click", function () {
                    this.classList.toggle("active");
                    var content = this.nextElementSibling;
                    if (content.style.display === "block") {
                        content.style.display = "none";
                    } else {
                        content.style.display = "block";
                    }
                });
            }
        }
    }


    CroppingVariants = {
        init: function () {
            function croppingImages() {
                var cropImage = $('.crop-image');
                cropImage.each(function () {
                    var parent = $('0'),
                        desktopAttr = $(this).attr('data-crop-variant-default'),
                        tabletAttr = $(this).attr('data-crop-variant-tablet'),
                        mobileAttr = $(this).attr('data-crop-variant-phone'),
                        viewportWidth = $("body").innerWidth();

                    if ($(this).parent().hasClass('fp-tableCell')) {
                        parent = $(this).parent().parent();
                    } else {
                        parent = $(this).parent();
                    }

                    if (viewportWidth <= 480) {
                        $(parent).css('background-image', 'url(' + mobileAttr + ')');

                    } else if (viewportWidth <= 1024) {
                        $(parent).css('background-image', 'url(' + tabletAttr + ')');

                    } else {
                        $(parent).css('background-image', 'url(' + desktopAttr + ')');

                    }
                })
            }

            $(document).ready(croppingImages);
            $(window).resize(croppingImages)
        }
    };

    downloadTable = {
        init: function () {
            if ($('.tabledownload').length) {
                var link = $('.tabledownload td a');

                $(link).each(function () {
                    if ($(this).text().includes('download') ||
                        $(this).text().includes('Download') ||
                        $(this).text().includes('PDF')) {
                        $(this).addClass('download')
                    }
                })
            }
        }
    };

    CanvasMenu = {
        init: function () {
            const mobileMenu = $('.drawer');
            const mobileMenuToggle = $('.hamburger');
            const lvl1 = $(mobileMenu).find('.lvl1');
            const sub = $(mobileMenu).find('.sub')
            const toggle = $(mobileMenu).find('.toggle')

            $(sub).slideToggle('fast')

            $(mobileMenuToggle).click(function () {
                $(this).toggleClass('is-active')
                $(mobileMenu).toggleClass('active')
            });
            $(lvl1).each(function () {
                if ($(this).find('.sub li').length === 0) {
                    $(this).find('.toggle').remove()
                }
            })
            $(toggle).click(function () {
                $(this).toggleClass('active')
                $(this).nextAll(".sub").first().slideToggle('slow')
            })
        }
    };

    Breadcrumb = {
        init: function () {
            var report = $(".report-stage-wrapper");
            var annualBreadcrumb = $(".annual-breadcrumb");

            if (report.length > 0) {
                $(annualBreadcrumb).css({
                    display: "none"
                })
            }

            var slider = $("#myCarousel");
            var breadcrumb = $(".breadcrumb");

            if (breadcrumb.length > 0) {
                $(slider).css({
                    position: "relative"
                })
            }


        }
    };

    reportStage = {
        init: function () {
            var reportStage = $(".report-stage-wrapper");
            var reportArrow = $(".report-arrow");
            var mainContent = $(".main-content");

            if ($(reportStage).length) {

                $(reportArrow).on('click', function () {
                    $('html, body').animate({
                        scrollTop: $(".main-content").offset().top
                    }, 2000);
                });
                $(mainContent).css({
                    paddingTop: '0px'
                })

            }


        }
    };

    Glossar = {
        init: function () {
            // Sort result
            $(".glossar .content .section").sort(sort_li).appendTo('.glossar .content');

            function sort_li(a, b) {
                return ($(b).data('action')) < ($(a).data('action')) ? 1 : -1;
            }

            // Scroll to
            var selectcharacter = $(".selectbar .character");
            $(selectcharacter).on('click', function () {
                var selected = $(this).attr('data-action');
                var section = $(".section[data-action=" + selected + "]");
                if ($(section).length > 0) {
                    $('html, body').animate({
                        scrollTop: $(section).offset().top - 100
                    }, 2000);
                }
            });

            // Character without value
            var character = $(".glossar .selectbar .character");
            $(character).each(function () {
                var selected = $(this).attr('data-action');
                var section = $(".section[data-action=" + selected + "]");
                if (!$(section).length > 0) {
                    $(this).css({
                        display: "none"
                    });
                }
            });
        }
    };

    globalDownload = {
        init: function () {
            var closeButton = $(".global-download .close");
            var openDownload = $(".box.download.icon-wolke");
            var openSearch = $(".box.search.icon-lupe");

            var globalLayer = $(".global-download");
            var downloadArea = $(".global-download .download");
            var searchArea = $(".global-download .search");

            $(closeButton).on('click', function () {
                $(globalLayer).fadeOut(300);
                $(downloadArea).fadeOut(300);
                $(searchArea).fadeOut(300);
            });
            $(openDownload).on('click', function () {
                $(globalLayer).fadeIn(300);
                $(downloadArea).fadeIn(300);
            });
            $(openSearch).on('click', function () {
                $(globalLayer).fadeIn(300);
                $(searchArea).fadeIn(300);
            });
        }
    };

    responsiveTable = {
        init: function () {
            /*
             var tableWrap = $(".table-wrap");
             var tableContent = $(".contenttable");
             var tableScroll = $(".scroll-right");
             var innerScroll = $(".responsive-table");

             function scrollDetect() {
             if ($(tableWrap).find(tableContent).width() > $(tableWrap).width()) {
             $(tableWrap).find(tableScroll).addClass('active');
             $(tableWrap).addClass('active');
             } else {
             $(tableWrap).find(tableScroll).removeClass('active');
             $(tableWrap).removeClass('active');
             }
             }
             scrollDetect();
             $( window ).resize(function() {
             scrollDetect();
             });

             var windowWidth = $(window).width();

             if(windowWidth > 1024) {
             $('.responsive-table').perfectScrollbar();
             }


             $(tableScroll).click(function() {
             var innerWidth = $(innerScroll).width();
             var outerWidth = $(tableContent).width();
             var scrollDis = outerWidth - innerWidth;

             $(innerScroll).animate( { scrollLeft: scrollDis + 40 }, 50);
             });
             */

            var tableArrow = responsiveTable.checkTableArrow();

            $(".ce-table .scroll-right").click(function () {
                var btn = $(this);
                var table = $(this).siblings(".table-content");

                var width = table.find("table")[0].scrollWidth;
                var left = table.scrollLeft();
                var screen = $(window).width();
                var offset = left + screen;

                table.stop().animate({ scrollLeft: offset }, 750);

                var limit = left + (screen * 2);

                if (limit > width) {
                    btn.addClass("hidden");
                    btn.siblings(".scroll-left").removeClass("hidden");
                }
            });

            $(".ce-table .scroll-left").click(function () {
                var btn = $(this);
                var table = $(this).siblings(".table-content");

                var width = table.find("table")[0].scrollWidth;
                var left = table.scrollLeft();
                var screen = $(window).width();
                var offset = left - screen;

                table.stop().animate({ scrollLeft: offset }, 750);

                var limit = left - screen;

                if (limit < 0) {
                    btn.addClass("hidden");
                    btn.siblings(".scroll-right").removeClass("hidden");
                }
            });
        },

        checkTableArrow: function () {
            var showArrow = false;
            $('.ce-table:visible').each(function () {
                var ceTable = $(this),
                    contentTable = ceTable.find('.table-content'),
                    table = contentTable.find('table'),
                    tableArrows = ceTable.find('.scroll-button');

                if (contentTable.width() < table.width() - 100) {
                    showArrow = true;
                } else {
                    tableArrows.hide();
                }
            });

            return showArrow;
        }
    };

    pdfLink = {
        init: function () {
            if ($('.canvas-menu ul.main ul li a').length) {
                $('.canvas-menu ul.main ul li a').each(function (index) {
                    var attr = $(this).attr('href');
                    if (typeof attr !== typeof undefined && attr !== false) {
                        var pdf = $(this).attr('href');
                        var test = pdf.search('.pdf');

                        if (test != '-1') {
                            $(this).prepend("<span class='menu-download icon-wolke_klein'></span>");
                        }
                    }
                })
            }
        }
    };

    historyBack = {
        init: function () {

            /*var referrer = document.referrer.toLowerCase();

             if(referrer.match(/\.gb2016-en.deutsche-beteiligung\.domain/g)){

             }

             jQuery(document).ready(function($) {

             if (window.history && window.history.pushState) {

             window.history.pushState('forward', null, './#forward');

             $(window).on('popstate', function() {

             });

             }
             });*/

        }
    };

    stickyNavigation = {
        init: function () {

            var metaNav = $(".meta-navigation");

            if (metaNav.length > 0 && $('html').hasClass('no-csspositionsticky')) {

                var navi = $(".navigation.website");
                var content = $(".main-content");

                $(function () {
                    $(window).scroll(function () {
                        var windowHeight = $(window).height();
                        if ($(this).scrollTop() >= windowHeight - 90) {
                            $(navi).add(content).addClass('sticky');
                        }
                        else {
                            $(navi).add(content).removeClass('sticky');
                        }
                    });
                });
            }
        }
    };

    equalHeight = {
        init: function () {

            var ident3 = $(".ce-factsnack .row-eq-height > div, .report-area .row-eq-height > div");
            var heights3 = $(ident3).map(function () {
                return $(this).innerHeight();
            }).get(),
                maxHeight3 = Math.max.apply(null, heights3);
            $(ident3).innerHeight(maxHeight3);

        }
    };

    teamDialog = {
        init: function () {
            var dialog = $(".team .dialog");
            var close = $(".team .dialog .close");
            var background = $(".background-fade");
            var box = $("body .team .box, body .team .button");
            var scrollfunction = $('.dialog .scroll-function');

            /*function equalheight() {
             var ident = $(".row-eq-height > div:visible");
             var heights = $(ident).map(function () {
             return $(this).innerHeight();
             }).get(),
             maxHeight = Math.max.apply(null, heights);
             $(ident).innerHeight(maxHeight);
             }*/

            if (!$('body.ogb18').length) {

                $(box).add(close).on('click', function ($e) {
                    $(this).next('.dialog').fadeToggle("slow", function () {
                        var left = $(".team .left").height();
                        var right = $(".team .right").height();
                        $(this).next('.background-fade').fadeToggle("slow", function () {
                        });
                    });

                    if ($(this).hasClass('close')) {
                        $(dialog).add(background).fadeOut(300);
                    } else {
                        if ($(this).next(scrollfunction).length) {
                            var image = $(this).next(dialog).find('.image').height();
                            var info = $(this).next(dialog).find('.info').height();

                            $(this).next(dialog).find(scrollfunction).height(image + info - 70);
                            //equalheight();
                        }
                    }
                    $e.preventDefault();
                    return false;
                });
            }


            $(window).resize(function () {
                $(dialog).add(background).fadeOut(300);
            });

        }
    };

    stageVideo = {
        init: function () {


            $('.close').each(function (index) {
                $(this).attr('ident', index)
            })

            $(".carousel-inner .play-button").on('click', function () {
                var VideoId = $(this).attr('id');
                var videoContainer = $('#modal-' + VideoId);
                videoContainer.fadeIn(300);
                $(videoContainer).find('.video').css('display', 'block')
                var video = videoContainer.find("video")[0];
                video.play();
            });

            $(".carousel-inner .close").on('click', function () {
                var videoContainer = $(this).closest(".carousel-inner").find(".video");
                videoContainer.fadeOut(300);
                var video = videoContainer.find("video")[$(this).attr('ident')];
                video.pause();
                // delay to avoid flashing while setting time to begin
                var timeout = setTimeout(function () {
                    video.pause();
                    video.currentTime = 0;
                }, 350);
            });
        }
    };

    newsVideo = {
        init: function () {

            $('.close').each(function (index) {
                $(this).attr('ident', index)
            })

            $(".newsCarousel .carousel-inner .play-button,.newsCarouselMobil .carousel-inner .play-button").on('click', function () {
                $('.desk-background-fade').fadeIn("slow", function () { });
                $('.res-background-fade').fadeIn("slow", function () { });
                var VideoId = $(this).attr('id');
                var videoContainer = $('#modal-' + VideoId);
                $(videoContainer).fadeIn(300);
                $(videoContainer).find('.video').css('display', 'block')
                var video = $(videoContainer).find("video")[0];
                video.play();
            });


            $(".newsVideoWrap .close").on('click', function () {
                var videoContainer = $(this).closest(".dialog");
                videoContainer.fadeOut(300);
                var video = videoContainer.find("video")[0];
                if (video) {
                    video.pause();
                }
                // delay to avoid flashing while setting time to begin
                var timeout = setTimeout(function () {
                    video.pause();
                    video.currentTime = 0;
                }, 350);
                $('.desk-background-fade').fadeOut("slow", function () { });
                $('.res-background-fade').fadeOut("slow", function () { });
            });
        }
    };

    headerVideo = {
        init: function () {

            let headerVideo = document.getElementById("headerVideo");
            if (!headerVideo) {
                return;
            }

            function autoStartVideo() {
                if (headerVideo) {
                    headerVideo.autoplay = true;
                    headerVideo.muted = true;
                    headerVideo.load();
                    headerVideo.controls = false;
                }
            }
            let mediaQuery = window.matchMedia("(min-width: 992px)");
            if (mediaQuery.matches) {
                if (typeof headerVideo.load === 'function') {
                    autoStartVideo();
                }




            } else {

                let contentElementVideoMobile = document.getElementsByClassName("header-video__mobile");
                let contentElementVideoContent = document.getElementsByClassName("header-video__content");
                let contentElementVideoDesktop = document.getElementsByClassName("header-video__desktop");

                // show image on mobile devices
                if (contentElementVideoMobile[0]) {
                    contentElementVideoMobile[0].style.display = 'block';
                }
                if (contentElementVideoContent[0]) {
                    contentElementVideoContent[0].style.display = 'block';
                }
                // hide desktop video
                if (contentElementVideoDesktop[0]) {
                    contentElementVideoDesktop[0].style.display = 'none';
                }
            }
        }
    }

    companyMap = {
        init: function () {

            setTimeout(function () {
                var detailMap = $('.map .co-master-d .point');
                var largelMap = $('.map .point');

                var actionArea = $('.map .connect');
                var startArea = $('.map .overview');
                var secCompanies = $('.map .co-second');

                if ($(largelMap).parent().hasClass('startscreen')) {
                    $(detailMap).closest('.detail-map').css({ display: 'none' });
                    $(startArea).css({ opacity: '0' });
                    $(actionArea).css({ opacity: '1' });
                    $(actionArea).find('.startscreen').css({ opacity: '1' });

                    var dataSelect = $(actionArea).find('.startscreen').attr("id");
                    $(actionArea).find('#' + dataSelect + ',.point.' + dataSelect).css({ opacity: '1' });
                    $(actionArea).find('.line.' + dataSelect).animate({
                        opacity: 1
                    }, 1500, function () {
                    });

                }

                $(detailMap).on('click', function () {
                    var dataSelect = $(this).parent().attr("data-ident");

                    $(detailMap).parent().removeClass('active');
                    $(detailMap).parents('.map').find('.area').removeClass('active');
                    $(detailMap).parent().find('.company').removeClass('active');
                    $(startArea).css({ opacity: '0', display: 'none' });
                    $(actionArea).css({ opacity: '1' });


                    $(actionArea).find('.co-master, .line').css({ opacity: '0' });
                    $(actionArea).find('.co-second').parent().css({ opacity: '0', visibility: 'hidden' });
                    $(actionArea).find('.co-second').css({ opacity: '0' });

                    $(actionArea).find('#' + dataSelect + ',.point.' + dataSelect).parent().css({
                        opacity: '1',
                        visibility: 'visible'
                    });
                    $(actionArea).find('.co-master').css({ zIndex: 0 });
                    $(actionArea).find('#' + dataSelect + ',.point.' + dataSelect).css({ opacity: '1', zIndex: 100 });

                    $(actionArea).find('.' + dataSelect).css({ opacity: '1' });
                    $(this).parent().find('.company').addClass('active');
                    $(actionArea).find('.line.' + dataSelect).animate({
                        opacity: 1,
                        width: '0.08em'
                    }, 2000, function () {
                    });
                    $(this).parent().addClass('active');
                    $(this).parent().next('.area').addClass('active');
                });

                /*$(secCompanies).on('click', function() {
                 $(secCompanies).removeClass('active');
                 $(this).addClass('active');
                 });*/

                function adjustLine(from, to, line) {
                    setTimeout(function () {
                        var fT = from.offsetTop + from.offsetHeight / 2;
                        var tT = to.offsetTop + to.offsetHeight / 2;
                        var fL = from.offsetLeft + from.offsetWidth / 2;
                        var tL = to.offsetLeft + to.offsetWidth / 2;

                        var CA = Math.abs(tT - fT);
                        var CO = Math.abs(tL - fL);
                        var H = Math.sqrt(CA * CA + CO * CO);
                        var ANG = 180 / Math.PI * Math.acos(CA / H);

                        if (tT > fT) {
                            var top = (tT - fT) / 2 + fT;
                        } else {
                            var top = (fT - tT) / 2 + tT;
                        }
                        if (tL > fL) {
                            var left = (tL - fL) / 2 + fL;
                        } else {
                            var left = (fL - tL) / 2 + tL;
                        }

                        if ((fT < tT && fL < tL) || (tT < fT && tL < fL) || (fT > tT && fL > tL) || (tT > fT && tL > fL)) {
                            ANG *= -1;
                        }
                        top -= H / 2;

                        line.style["-webkit-transform"] = 'rotate(' + ANG + 'deg)';
                        line.style["-moz-transform"] = 'rotate(' + ANG + 'deg)';
                        line.style["-ms-transform"] = 'rotate(' + ANG + 'deg)';
                        line.style["-o-transform"] = 'rotate(' + ANG + 'deg)';
                        line.style["-transform"] = 'rotate(' + ANG + 'deg)';
                        line.style.top = top + 'px';
                        line.style.left = left + 'px';
                        line.style.height = H + 'px';
                    }, 500);
                }

                function line_init() {
                    $('.calc-box').each(function (index) {
                        var masterPoint = $('.co-master').attr('id');
                        var toPoint = $(this).find('.co-second').attr('id');
                        var linePoint = $(this).find('.line').attr('id');

                        adjustLine(
                            document.getElementById(masterPoint),
                            document.getElementById(toPoint),
                            document.getElementById(linePoint)
                        );
                    });
                };
                line_init();

                $(window).resize(function () {
                    line_init();
                });

            }, 2000);

        }
    };

    anchorFix = {
        init: function () {

            var ancor = $('.ancor');

            if ($(ancor).length > 0) {
                $(ancor).each(function (index) {
                    var dataAncor = $(this).attr('data-ancor');
                    var body = $('body');
                    var ancorPosition = body.find("[data-ancor='" + dataAncor + "']").position();
                    var ancorelementPosition = body.find("[data-ancor-element='" + dataAncor + "']");

                    $(ancorelementPosition).css({ top: ancorPosition.top });
                });
            }
        }
    };

    tableFunctions = {
        init: function () {

            function filterPortfolio() {

                let periodMin = $('input[name="periodfrom-min"]:checked').val();
                let periodMax = $('input[name="periodfrom-max"]:checked').val();

                var filterFormer = false;
                if ($('.portfolio-switch-type .button.active[data-filter-former]').length)
                    filterFormer = $('.portfolio-switch-type .button.active').data('filter-former');

                $portfoliogrid.isotope({
                    filter: function () {

                        var portfolioElement = $(this);

                        //check for former
                        if (filterFormer && !portfolioElement.hasClass(filterFormer))
                            return false;

                        //check for sector
                        if ($('.brancheCheckboxes input[data-filter-sector]:checked').length) {
                            var found = false;
                            $('.brancheCheckboxes input[data-filter-sector]:checked').each(function (index) {
                                // if(!$(this).hasClass(filterFormer))
                                if (portfolioElement.hasClass($(this).data('filter-sector'))) {
                                    found = true;
                                    return;
                                }
                            });
                            if (!found)
                                return false;
                        }

                        //check for type
                        if ($('.adbCheckboxes input[data-filter-type]:checked').length) {
                            var found = false;
                            $('.adbCheckboxes input[data-filter-type]:checked').each(function (index) {
                                // if(!$(this).hasClass(filterFormer))
                                if (portfolioElement.hasClass($(this).data('filter-type'))) {
                                    found = true;
                                    return;
                                }
                            });
                            if (!found)
                                return false;
                        }

                        let year = portfolioElement.data('periodfrom-year');
                        if (year < periodMin)
                            return false;

                        if (year > periodMax)
                            return false;

                        return true;

                    }
                });


            }

            var table = $('#myTable').DataTable({
                "paging": false,
                "ordering": true,
                "info": false,
                "searching": true,
                "columnDefs": [
                    {
                        "targets": [5, 6],
                        "visible": false
                    }
                ]
            });


            if ($('.table-lang').text() == 'de') {
                var search = $('#myTable_filter');
                var res = search.html().replace("Search", "Suche");
                search.html(res)
            }

            //$(".tablesorter").stupidtable();


            // if (table.data('lang') == 'de') {
            // 	table.dataTable({
            // 		paging: false,
            // 		"language": {
            // 			"url": "//cdn.datatables.net/plug-ins/1.10.15/i18n/German.json"
            // 		}
            // 	});
            // } else {
            // 	table.dataTable({
            // 		paging: false,
            // 		"language": {
            // 			"url": "//cdn.datatables.net/plug-ins/1.10.15/i18n/English.json"
            // 		}
            // 	});
            // }

            $(".showHide").click(function (e) {
                e.preventDefault();
                $(".searchTags").slideToggle("slow");
            });

            $('#myTable_length, #myTable_info, #myTable_paginate').css('display', 'none');
            // table.find('tr[data-link]').on('click', function () {
            // 	var self = $(this),
            // 		dataLink = self.data('link');
            // 	if (dataLink[0] != '/') dataLink = '/' + dataLink;
            // 	window.location.href = dataLink;
            // });

            $('input.filter').on('change', function () {
                table.draw();
            });
            $('input.filter2').on('change', function () {
                table.draw();
            });

            // example https://codepen.io/desandro/pen/btFfG
            $('input.portfolio-tile-filter').on('change', function () {
                filterPortfolio();
            });

            $.fn.dataTable.ext.search.push(
                function (settings, searchData, index, rowData, counter) {
                    // No filtered checked - show all rows
                    if ($('.filter:checked').length === 0) {
                        return true;
                    }

                    // Filter(s) checked, apply logic
                    var found = false;
                    $('.filter').each(function (index, elem) {
                        if (elem.checked && rowData[2] == elem.value) {
                            found = true;
                        }
                    });

                    return found;
                }
            );
            $.fn.dataTable.ext.search.push(
                function (settings, searchData, index, rowData, counter) {
                    // No filtered checked - show all rows
                    if ($('.filter2:checked').length === 0) {
                        return true;
                    }

                    // Filter(s) checked, apply logic
                    var found = false;
                    $('.filter2').each(function (index, elem) {
                        if (elem.checked && rowData[1] == elem.value) {
                            found = true;
                        }
                    });

                    return found;
                }
            );
            $.fn.dataTable.ext.search.push(
                function (settings, searchData, index, rowData, counter) {
                    if ($('.portfolio-switch-type .button.active[data-filter-former]').length) {
                        filterFormer = $('.portfolio-switch-type .button.active').data('filter-former');
                        if (rowData[5] != filterFormer)
                            return false;
                    }

                    return true;
                }
            );

            $.fn.dataTable.ext.search.push(
                function (settings, searchData, index, rowData, counter) {
                    let periodMin = $('input[name="periodfrom-min"]:checked').val();
                    let periodMax = $('input[name="periodfrom-max"]:checked').val();
                    let year = rowData[6];

                    if (year < periodMin)
                        return false;

                    if (year > periodMax)
                        return false;

                    return true;
                }
            );

            var portfolioSwitchView = $('.portfolio-switch-view>div');
            $(portfolioSwitchView).on('click', function () {
                $(portfolioSwitchView).removeClass("active");
                $(this).addClass("active");

                const showSelector = $(this).data("content-selector");
                if ($('.list-view[data-layout-isotope-on-show="true"]').length) {
                    $('.list-view[data-layout-isotope-on-show="true"]').removeAttr("data-layout-isotope-on-show");
                    $(showSelector).show(0, function () {
                        $('.portfolio-tile-overview').isotope('layout');
                    });
                }
                else
                    $(showSelector).show('fast');

                $($('.portfolio-switch-view>div:not(.active)').data("content-selector")).hide("fast");

            });

            var portfolioSwitchType = $('.portfolio-switch-type>div');

            $(portfolioSwitchType).on('click', function () {
                $('.list-view.active[data-content-selector=".list-overview"]').attr('data-layout-isotope-on-show', 'true');
                $(portfolioSwitchType).removeClass("active");
                $(this).addClass("active");
                filterPortfolio();
                table.draw();
            });

            if ($('.periodfrom-filter').length > 0) {
                let min = false;
                let max = false;

                let minItemTemplate = $('#periodfrom-min').html();
                let maxItemTemplate = $('#periodfrom-max').html();
                $('.periodfrom-filter').html('');

                $('*[data-periodfrom-year]').each(function (index) {
                    if ($(this).data('periodfrom-year') >= 2000) {
                        let year = $(this).data('periodfrom-year');
                        if (min === false || min > year)
                            min = year;
                        if (max === false || max < year)
                            max = year;
                    }
                });
                for (year = max; year >= min; year--) {
                    if ($('*[data-periodfrom-year="' + year + '"]').length) {
                        let itemMin = $(minItemTemplate);
                        itemMin.children('input').attr('id', 'periodfrom-min-' + year).val(year);
                        itemMin.children('label').attr('for', 'periodfrom-min-' + year).text(year);
                        $('#periodfrom-min').append(itemMin);
                        //$('#periodfrom-min>*:first-child>input').prop('checked', true);
                        $('#periodfrom-min>*:last-child>input').prop('checked', true);

                        let itemMax = $(maxItemTemplate);
                        itemMax.children('input').attr('id', 'periodfrom-max-' + year).val(year);
                        itemMax.children('label').attr('for', 'periodfrom-max-' + year).text(year);
                        $('#periodfrom-max').append(itemMax);
                        //$('#periodfrom-max>*:last-child>input').prop('checked', true);
                        $('#periodfrom-max>*:first-child>input').prop('checked', true);
                    }
                }

                // $('.periodfrom-max-button span').text(' ' + $('input[name="periodfrom-max"]:checked').val());
                // $('.periodfrom-min-button span').text(' ' + $('input[name="periodfrom-min"]:checked').val());

                $('.periodfrom-filter input').change(function () {

                    if ($('input[name="periodfrom-min"]:checked').val() > $('input[name="periodfrom-max"]:checked').val())
                        $('.periodfrom-filter input[value="' + $(this).val() + '"]').prop('checked', true);

                    $('.periodfrom-max-button span').text(' ' + $('input[name="periodfrom-max"]:checked').val());
                    $('.periodfrom-min-button span').text(' ' + $('input[name="periodfrom-min"]:checked').val());

                    filterPortfolio();
                    table.draw();
                });

            }

            // isotope portfolio
            if ($('.ce-portfolio-overview').length > 0) {

                var $portfoliogrid = $('.portfolio-tile-overview').isotope({

                    itemSelector: '.isotope-item',

                    resizesContainer: true,
                    transformsEnabled: false,
                    masonry: {
                        resizesContainer: false,
                        transformsEnabled: false,
                        gutter: 20,
                    }
                });

                $portfoliogrid.isotope('layout');
            }

        }
    };

    isotopSort = {
        init: function () {

            // shows the year label s
            function showLabel() {
                if ($('.tx-mpmnews .tx_mpmnews .ce-table').length > 0) {
                    var value;
                    $('tr.header').removeClass('double');
                    $('tr.header').each(function () {
                        if (value == $(this).attr('data-header')) {
                            $(this).addClass('double');
                        }
                        value = $(this).attr('data-header');
                    });
                    value = 0;
                }
            }

            showLabel();

            // Only the first teaser
            function bigTeaser() {
                var teaser_select = $('.tx-mpmnews .tx_mpmnews .block-grid-item.big');

                if ($(teaser_select).length > 0) {
                    $(teaser_select).each(function (index) {
                        if (index < 1) {
                            var container = $(this);
                            $(this).remove();
                            $(".block").prepend(container);
                        }
                        if (index > 0) {
                            $(this).removeClass('big');
                        }
                    })
                }

                // Removes doubble teaser
                /*var get_id = $(teaser_select).attr('id');
                 if (get_id) {
                 $('.tx-mpmnews .tx_mpmnews .block-grid-item#small' + get_id).remove();
                 }*/

            }

            bigTeaser();


            if ($('.tx_mpmnews').length > 0) {

                // init Isotope
                var $grid = $('.tx_mpmnews .block, .tx_mpmnews table tbody').isotope({
                    resizesContainer: false,
                    transformsEnabled: false,
                    masonry: {
                        resizesContainer: false,
                        transformsEnabled: false,
                        columnWidth: 100
                    },
                    sortBy: 'date'
                });


                // filter items
                var $filterButtonGroup = $('.tx_mpmnews .filter');
                var filterSelect = $('.tx_mpmnews .filter button');
                $(filterSelect).each(function () {
                    var current = $(this).attr('data-filter');
                    $(this).addClass('current');
                    $(filterSelect).filter("[data-filter='" + current + "']").not('.current').remove();
                }).promise().done(function () {
                    $('.tx-mpmnews .tx_mpmnews').css({ opacity: '1' });
                });


                var filters = {};

                $(filterSelect).on('click', function () {
                    var $this = $(this);
                    // get group key
                    var $buttonGroup = $this.parents('.button-group');
                    var filterGroup = $buttonGroup.attr('data-filter-group');
                    // set filter for group
                    filters[filterGroup] = $this.attr('data-filter');
                    // combine filters
                    var filterValue = concatValues(filters);
                    $grid.isotope({ filter: filterValue + ',.isotope' });
                    location.hash = 'filter=' + encodeURIComponent(filterValue);

                    isotopSort.loadMore(initShow);
                });

                // flatten object by concatting values
                function concatValues(obj) {
                    var value = '';
                    for (var prop in obj) {
                        value += obj[prop];
                    }
                    return value;
                }


                //****************************
                // Isotope Load more button
                //!****************************
                var initShow = 21; //number of items loaded on init & onclick load more button
                var counter = initShow; //counter for load more button
                var iso = $grid.data('isotope'); // get Isotope instance

                isotopSort.loadMore(initShow); //execute function onload


                //append load more button
                //$grid.after('<button id="load-more" class="link-button"> Load More</button>');


                //when load more button clicked

                $("#load-more").click(function () {
                    var filtersButton = $('.filters button, .filters .data-select');
                    if (filtersButton.data('clicked')) {
                        //when filter button clicked, set initial value for counter
                        counter = initShow;
                        filtersButton.data('clicked', false);
                    }

                    counter = counter + initShow;

                    isotopSort.loadMore(counter);
                });

                //when filter button clicked
                /*$(".tx_mpmnews .filter").click(function () {
                 $(this).data('clicked', true);
                 isotopSort.loadMore(initShow);
                 });*/


                // URL HASH
                function getHashFilter() {
                    // get filter=filterName
                    var matches = location.hash.match(/filter=([^?]+)/i);
                    var hashFilter = matches && matches[1];


                    // disables the category column
                    $('.tx-mpmnews .ce-table td.category').css({ display: 'table-cell' });
                    if (encodeURIComponent(hashFilter).match('cat')) {
                        $('.tx_mpmnews .ce-table .contenttable .header .category').addClass('d-none');
                    }
                    $('.all').click(function () {
                        $('.tx_mpmnews .ce-table .contenttable .header .category').removeClass('d-none');
                    });
                    return hashFilter && decodeURIComponent(hashFilter);
                }

                // filter functions
                var filterFns = {
                    // show if name ends with -ium
                    ium: function () {
                        var name = $(this).find('.name').text();
                        return name.match(/ium$/);
                    }
                };

                var isIsotopeInit = false;

                function onHashchange() {
                    var hashFilter = getHashFilter();
                    if (!hashFilter && isIsotopeInit) {
                        return;
                    }
                    isIsotopeInit = true;
                    // filter isotope

                    $(document).ready(function () {
                        if ($('#p-189').length > 0) {
                            $grid.isotope({
                                itemSelector: '.element-item',
                                //layoutMode: 'fitRows',
                                // use filterFns
                                filter: hashFilter + ',.isotope'

                            });
                        } else {
                            $grid.isotope({
                                itemSelector: '.element-item',
                                //layoutMode: 'fitRows',
                                // use filterFns
                                filter: hashFilter
                            });
                        }

                    })

                    // set selected class on button
                    if (hashFilter) {
                        $filterButtonGroup.find('.is-checked').removeClass('is-checked');
                        //$filterButtonGroup.find('[data-filter="' + hashFilter + '"]').addClass('is-checked');

                        var arr = hashFilter.split('.');
                        $filterButtonGroup.find('[data-filter=".' + arr[1] + '"]').addClass('is-checked');
                        $filterButtonGroup.find('[data-filter=".' + arr[2] + '"]').addClass('is-checked');

                        if (arr[0] == '*') {
                            $filterButtonGroup.find('[data-filter="*"]').addClass('is-checked');
                        }
                    }
                    else {
                        $filterButtonGroup.find('[data-filter="*"]').addClass('is-checked');
                    }
                }

                $(window).on('hashchange', onHashchange);

                // trigger event handler to init Isotope
                onHashchange();
                // /URL HASH
            }
        },
        loadMore: function (toShow) {

            setTimeout(
                function () {

                    var $grid = $('.tx_mpmnews .block, .tx_mpmnews table tbody').isotope({
                        masonry: {
                            columnWidth: 100
                        }
                    });

                    var iso = $grid.data('isotope'); // get Isotope instance
                    $grid.find(".hidden").removeClass("hidden");

                    var hiddenElems = [];
                    var counter = 0;

                    var filterClass = isotopSort.getHashFilter();

                    if (typeof filterClass === "string") {
                        filterClass = filterClass.substr(1);
                    }

                    iso.filteredItems.forEach(function (item) {
                        if (item.element.classList.contains(filterClass) || !filterClass) {
                            counter++;

                            if (counter > toShow) {
                                hiddenElems.push(item.element);
                            }
                        } else {
                            hiddenElems.push(item.element);
                        }


                    });

                    if ($('.tx_mpmnews.archiv').length > 0 && filterClass != '') {

                    } else {
                        $(hiddenElems).addClass('hidden');
                    }


                    $grid.isotope('layout');


                    //when no more to load, hide show more button
                    if (hiddenElems.length == 0 || $('.tx_mpmnews.archiv').length > 0 && filterClass != '') {
                        jQuery("#load-more").hide();
                    } else {
                        jQuery("#load-more").show();
                    }

                }, 1);

        },
        getHashFilter: function () {
            // get filter=filterName
            var matches = location.hash.match(/filter=([^?]+)/i);
            var hashFilter = matches && matches[1];

            // disables the category column
            $('.tx-mpmnews .ce-table td.category').css({ display: 'table-cell' });
            if (encodeURIComponent(hashFilter).match('cat')) {
                $('.tx-mpmnews .ce-table td.category').css({ display: 'none' })
            }

            return hashFilter && decodeURIComponent(hashFilter);
        }

    };

    newsArchiv = {
        init: function () {
            var archiv = $('.archiv'),
                dropdown_button = $(archiv).find($('.choose')),
                dropdown_menu = $(archiv).find($('.selector')),
                buttons = $('.filter .button-group button');

            $(dropdown_button).on('click', function () {
                $(dropdown_menu).slideToggle();
            });

            var $grid = $('.archiv .contenttable tbody');
            $grid.isotope({
                itemSelector: '.list'
            });

            function concatValues(obj) {
                var value = '';
                for (var prop in obj) {
                    value += obj[prop];
                }
                return value;
            }
            var filters = {};
            //var FilterAttr, YearAttr = '';
            $(buttons).click(function () {
                if ($(this).hasClass('filterbutton')) {
                    $('.filterbutton').removeClass('is-checked');
                    $(this).addClass('is-checked');
                    $('td.category').hide();
                    if ($(this).hasClass('all')) {
                        $(archiv).find('.category').show();
                        $('td.category').show();
                    }
                } else {
                    $('.filters').removeClass('is-checked');
                    $(this).addClass('is-checked');
                }
                var $this = $(this);
                // get group key
                var $buttonGroup = $this.parents('.button-group');
                var filterGroup = $buttonGroup.attr('data-filter-group');
                // set filter for group
                filters[filterGroup] = $this.attr('data-filter');
                // combine filters
                var filterValue = concatValues(filters);
                $grid.isotope({ filter: filterValue });


                // console.log('.'+FilterAttr+' .'+YearAttr+'')
                // $grid.isotope({filter: '.Aktuelles,.2020'});


                // if ($(this).hasClass('filterbutton')) {
                //     $(archiv).find('.category').hide();
                //
                // }
                // if($('.filters').hasClass('is-checked'))  {
                //     console.log('test1')
                //     var  year = $('.filters.is-checked').attr('data-filter');
                //
                // } else  {
                //     console.log('test')
                //     $grid.isotope({filter: attr});
                // }
                // $(buttons).removeClass('is-checked');
                // $(this).addClass('is-checked');
            });

            $(dropdown_menu).find('.filters').click(function () {
                $(archiv).find('.category').show();
            });

            var $container = $grid;
            var initShow = 12; //number of items loaded on init & onclick load more button
            var counter = initShow; //counter for load more button
            var iso = $container.data('isotope'); // get Isotope instance

            loadMore(initShow); //execute function onload

            function loadMore(toShow) {
                $container.find(".hidden").removeClass("hidden");

                var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function (item) {
                    return item.element;
                });
                $(hiddenElems).addClass('hidden');
                $container.isotope('layout');

                //when no more to load, hide show more button
                if (hiddenElems.length == 0) {
                    jQuery("#load-more").hide();
                } else {
                    jQuery("#load-more").show();
                };

            }

            //when load more button clicked
            $("#load-more").click(function () {
                if ($('.filters').data('clicked')) {
                    //when filter button clicked, set initial value for counter
                    counter = initShow;
                    $('.filters').data('clicked', false);
                } else {
                    counter = counter;
                };

                counter = counter + initShow;

                loadMore(counter);
            });

            //when filter button clicked
            $(".filters").click(function () {
                $(this).data('clicked', true);

                loadMore(initShow);
            });
        }
    };

    socialMedia = {
        init: function () {
            var social = $('.social');

            $(social).find('.icon').on('click', function (e) {
                e.preventDefault();
                var href = $(this).attr('href');
                window.open(href, 'targetWindow', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=600');
            });

            // Google Maps
            $(".google-maps .overlay").on('click', function () {
                $(".google-maps .overlay").css("pointer-events", "none");
            });
            $(".google-maps iframe").mouseleave(function () {
                $(".google-maps .overlay").css("pointer-events", "auto");
            });


            //LinkedIn - Formhandler
            /*var button = $('.autofill-linkedin');
             var url = 'https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=86w6qjeraopv0j&redirect_uri=https://www.dbag.de/unser-unternehmen/karriere/online-bewerbungsformular/';

             $(button).on('click', function() {
             window.open(url, '_blank');
             })*/

        }

    };

    megaMenu = {
        init: function () {
            var main_navi = $('.navigation');

            $(main_navi).find('ul li a').on('click', function (e) {

                if ($('.mega-menu').length > 0) {
                    var isOpen = $('.mega-menu').is('visible');
                    if (isOpen === true) {
                        e.preventDefault();
                        var ident = $(this).attr('href');

                        $('.navi-content ul.main > li').find("a[href='" + ident + "']").each(function (index) {
                            if (index < 1) {
                                $(this).click();
                            }
                        });
                    } else {
                        e.preventDefault();
                        $('.mega-menu').fadeIn();
                        var ident = $(this).attr('href');

                        $('.navi-content ul.main > li').find("a[href='" + ident + "']").each(function (index) {
                            if (index < 1) {
                                $(this).click();
                            }
                        });
                        $('.mega-menu .navigation ul > li').find("a[href='" + ident + "']").each(function (index) {
                            if (index < 1) {
                                $('.mega-menu .navigation ul > li').removeClass('active');
                                $(this).parent().addClass('active');
                            }
                        });
                    }

                }

            });

            var lev1 = $('.navi-content ul.main > li.subpages > span a');

            $(lev1).on('click', function (e) {
                var count = $(this).parents('li').find('> ul li').length;

                if (count > 1) {
                    e.preventDefault();
                    $(lev1).parents('li').find(' > ul').fadeOut();
                    $(this).parents('li').find('> ul').fadeIn();
                } else {
                    $('.mega-menu').css({ display: 'none' });
                    var url = $(this).attr('href');
                    /* IE Link Fix (absRefPrefix not working?!) */
                    if (url.charAt(0) != '/' && !url.match(/^http([s]?):\/\/.*/)) url = '/' + url;
                    window.location.href = url;
                }


                $(this).parents('li').find('ul.level3 li').each(function (index) {
                    if (index > 20) {
                        $(this).parent().parent().addClass('break');
                    }
                })

            });

            $('.mega-menu .navigation ul li a').on('click', function () {
                $('.mega-menu .navigation ul li').removeClass('active');
                $(this).parent().addClass('active');

            });

            /*$(lev1).parents('.subpages').find('ul li.subpages span a').on('click', function(e) {
             e.preventDefault();
             $(this).parent().parent().find('> ul').fadeToggle();

             });*/


            var mega_menu = $('.mega-menu');

            $(mega_menu).find('.closer').on('click', function () {
                $(mega_menu).fadeToggle();
            })

        }
    };

    chartHandler = {
        init: function () {
            var thousandsSeparator = '.';
            switch (glob.language) {
                case 'en':
                    thousandsSeparator = ',';
                    break;
            }
            var separator = ',';
            switch (glob.language) {
                case 'en':
                    separator = '.';
                    break;
            }

            function numberFormat($x) {
                //glob.debug(thousandsSeparator + ', ' + separator);

                var parts = $x.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
                return parts.join(separator);
            }

            var kennzahlen = $('.main-content').find('.kennzahlen');
            if (kennzahlen.length == 0) return;

            var open = false;
            var currentViewMode = 'bars';

            initCharts();

            kennzahlen
                .stop(true)
                .fadeIn(500);

            // init charts
            function initCharts() {
                //glob.debug('initCharts');
                var pages = kennzahlen.find('.pages').children();

                // view mode selector
                var viewModes = kennzahlen.find('.view');
                var viewModeLinks = viewModes.children('a');
                // currentViewMode = glob.storage.get('kz-viewmode');
                if (!currentViewMode) currentViewMode = 'bars';

                viewModeLinks.each(function () {
                    var self = $(this);
                    var mode = self.data('mode');
                    if (currentViewMode == mode) self.addClass('active');

                    self.fastclick(function () {
                        currentViewMode = mode;
                        // glob.storage.set('kz-viewmode', mode);
                        viewModeLinks.removeClass('active');
                        self.addClass('active');

                        // glob.trackEvent('chart-generator.view-mode.' + mode);

                        initChart(currentPage);
                        showCurrentChart();
                    });
                });

                // data source selector
                var btn = kennzahlen.find('.selector');
                var btnText = btn.children('span');
                var menu = btn.children('div').hide();
                var links = menu.children();

                links.eq(0).addClass('current');
                btnText.text(links.eq(0).text());
                var currentPage = pages.eq(0);
                initChart(currentPage);
                showCurrentChart(true);
                pages.not(currentPage).hide();

                function initChart($page) {
                    var renderTarget = $page.children('.chart-render-' + currentViewMode);
                    //glob.debug('.chart-render-' + currentViewMode);
                    //glob.debug(renderTarget);

                    // destroy old highchart for new animation
                    if (renderTarget.data('chartInit') === true) {
                        if (currentViewMode != 'table') {
                            renderTarget
                                .highcharts()
                                .destroy();
                        }

                        if (currentViewMode == 'table') {
                            renderTarget
                                .children().remove();
                            renderTarget
                                .append(highChartsConfig($page));
                            return;
                        }
                    }
                    // table init
                    else if (currentViewMode == 'table') {
                        renderTarget
                            .append(highChartsConfig($page))
                            .data('chartInit', true);
                        return;
                    }

                    // highcharts init
                    renderTarget
                        .css({
                            opacity: 0
                        })
                        .show()
                        .highcharts(highChartsConfig($page))
                        .data('chartInit', true)
                        .hide();
                }

                function showCurrentChart($fast) {
                    var currentChart = currentPage.find('[class*="chart-render-"]').filter(':visible');
                    var newChart = currentPage.children('.chart-render-' + currentViewMode);

                    if ($fast) {
                        if (currentChart.length > 0) currentChart.hide();
                        newChart
                            .css({
                                opacity: 1
                            })
                            .show();
                        return;
                    }

                    if (currentChart.length > 0) {
                        currentChart
                            .stop(true)
                            .animate({
                                opacity: 0
                            },
                                {
                                    duration: 250,
                                    complete: function () {
                                        currentChart.hide();

                                        newChart
                                            .stop(true)
                                            .css({
                                                opacity: 0
                                            })
                                            .show()
                                            .animate({
                                                opacity: 1
                                            },
                                                {
                                                    duration: 450
                                                });
                                    }
                                });

                        return;
                    }

                    newChart
                        .stop(true)
                        .css({
                            opacity: 0
                        })
                        .show()
                        .animate({
                            opacity: 1
                        },
                            {
                                duration: 450
                            });
                }

                // show chart page
                function showContent($page) {
                    var old = currentPage;
                    old
                        .stop(true)
                        .animate({
                            opacity: 0
                        },
                            {
                                duration: 250,
                                complete: function () {
                                    old.hide();
                                }
                            });

                    currentPage = $page;
                    currentPage
                        .stop(true)
                        .css({
                            opacity: 0
                        })
                        .show();

                    initChart(currentPage);
                    //currentPage.showElement();
                    showCurrentChart();

                    currentPage
                        .animate({
                            opacity: 1
                        },
                            {
                                duration: 450
                            });
                }

                function toggleMenu() {
                    if (btn.hasClass('open')) {
                        menu
                            .stop(true)
                            .slideUp(350);

                        btn.removeClass('open');
                        // glob.trackEvent('chart-generator.data-selector.close');
                        return;
                    }

                    menu
                        .stop(true)
                        .slideDown(550);

                    btn.addClass('open');
                    // glob.trackEvent('chart-generator.data-selector.open');
                }

                btn.children('span').fastclick(toggleMenu);

                links.each(function ($i) {
                    var link = $(this);
                    var content = pages.eq($i);
                    var trackTitle = glob.trackingUrlCleaner(link.html());

                    link.fastclick(function () {
                        links.removeClass('current');
                        link.addClass('current');
                        btnText.text(link.text());
                        toggleMenu();

                        // glob.trackEvent('chart-generator.data-selector.change-source.' + trackTitle);

                        showContent(content);
                    });
                });
            }

            // highchart + table configurations
            function highChartsConfig($page) {
                // build page configuration
                var dataXAxisLines = [];
                var dataXAxis = [];
                var data = [];

                $page.find('.data-xAxis').each(function () {
                    var self = $(this);
                    var name = self.data('chart-label');
                    dataXAxisLines.push(name);

                    data.push({
                        name: name
                    });
                });

                var dataUnit = $page.find('.data-yAxis').data('chart-label');
                // var dataUnitTooltip = $page.find('.data-yAxis').data('chart-label-tooltip');
                var dataUnitTooltip = [];
                // var dataYAxis = ' Angaben in ' + dataUnit;
                var dataYAxis = dataUnit;
                var footnotes = '';
                var dataLines = [];
                var colorAmount;
                var dataFootnotes = [];
                var dataDecimal = [];
                $page.find('.chart-row').each(function (i) {
                    var self = $(this);
                    var value = self.data('chart-value') + '';
                    var tmp = value.split('#');
                    colorAmount = tmp.length - 1;
                    value = [];
                    $.each(tmp, function ($index, $value) {
                        var floatVal = parseFloat($value);
                        value.push(floatVal);
                    });

                    // save bar diagram data
                    var name = self.data('chart-label') + '';
                    var part = {
                        name: name,
                        data: value
                    };
                    dataLines.push(part);
                    dataXAxis.push(self.data('chart-label') + ' ');

                    if (self.data('footnote-index')) footnotes += '<sup>' + self.data('footnote-index') + '</sup> ' + self.data('footnote') + '<br/>';

                    dataFootnotes.push(self.data('chart-footnotes').split('#'));
                    dataDecimal.push(self.data('chart-decimal'));
                    dataUnitTooltip.push(self.data('chart-label-tooltip'));
                });
                $('.chart-footnotes').html('<p>' + footnotes + '</p>');
                // save line diagram data (inverse xAxis)
                $.each(data, function ($index, $value) {
                    var value = [];

                    $.each(dataLines, function ($index2, $value2) {
                        value.push($value2.data[$index]);
                    });

                    $value.data = value;
                });

                var barColors = ['#f0ece6', '#e8e3da', '#d2ccc1', '#c2bdb0', '#b6b0a5', '#b3ab9c', '#a1998c', '#968d81', '#8e8073', '#004c98'];
                var colors = [];


                $.each(dataLines[0].data, function ($index, $value) {
                    // glob.debug($index + '/' + colorAmount);
                    // glob.debug(barColors.length-1-colorAmount+$index);
                    if ($index == colorAmount) {
                        colors.push(barColors[barColors.length - 1]);
                    }
                    else {
                        colors.push(barColors[barColors.length - 1 - colorAmount + $index]);
                        // colors.push(barColors[$index]);
                    }
                });
                var colorsLines = [];
                $.each(data[0].data, function ($index, $value) {
                    //glob.debug($index + '/' + colorAmount);
                    if ($index == data[0].data.length - 1) {
                        colorsLines.push(barColors[barColors.length - 1]);
                    }
                    else {
                        colorsLines.push(barColors[barColors.length - 1 - (data[0].data.length - 1) + $index]);
                        // colorsLines.push(barColors[$index]);
                    }
                });
                colorsLines.reverse();
                //glob.debug(colorsLines);

                var tooltip_bar = {
                    enabled: true,
                    borderWidth: 0,
                    borderColor: 'transparent',
                    useHTML: true,
                    shadow: false,
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    formatter: function () {
                        var decimal = dataDecimal[this.point.index];
                        var tooltipLabel = dataUnitTooltip[this.point.index];

                        var y = this.y + " ";
                        var wert = this.y.toFixed(decimal);
                        return numberFormat(wert) + ' ' + tooltipLabel;
                    }
                };

                var tooltip_line = {
                    enabled: true,
                    borderWidth: 0,
                    borderColor: 'transparent',
                    useHTML: true,
                    shadow: false,
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    formatter: function () {
                        var decimal = dataDecimal[this.series._i];
                        var tooltipLabel = dataUnitTooltip[this.series._i];

                        var y = this.y + " ";
                        var wert = this.y.toFixed(decimal);
                        return numberFormat(wert) + ' ' + tooltipLabel;
                    }
                };

                //glob.debug(dataYAxis);
                //glob.debug(dataXAxisLines);
                //glob.debug(data);
                //glob.debug(dataXAxis);
                //glob.debug(dataLines);

                switch (currentViewMode) {
                    case 'bars':
                        return {
                            chart: {
                                type: 'column',
                                spacingBottom: 100,
                                spacingLeft: 0,
                                spacingRight: 0,
                                plotBorderColor: '#4D4841',
                                height: null,
                                style: {
                                    fontFamily: 'Frutiger LT W02_45 Light, Times, Calibri, Helvetica, sans-serif'
                                }
                            },
                            title: {
                                style: {
                                    display: 'none'
                                }
                            },
                            subtitle: {
                                style: {
                                    display: 'none'
                                }
                            },
                            legend: {
                                y: 70
                            },
                            xAxis: {
                                categories: dataXAxis,
                                labels: {
                                    useHTML: true,
                                    style: {
                                        "color": "#666666",
                                        "cursor": "default",
                                        "fontSize": "11px",
                                        "padding": "0 20px",
                                        "text-align": "center",
                                        "white-space": "normal",
                                        "textOverflow": "none"
                                    }
                                }
                            },
                            yAxis: {
                                title: {
                                    text: dataYAxis
                                }
                            },
                            tooltip: tooltip_bar,
                            colors: colors,
                            plotOptions: {
                                column: {
                                    pointPadding: 0.2,
                                    borderWidth: 0,
                                    minPointLength: 1
                                },
                                series: {
                                    states: {
                                        hover: {
                                            color: '#F0F1F5'
                                        }
                                    }
                                }
                            },
                            series: data,
                            credits: {
                                enabled: false
                            }
                        };
                        break;
                    case 'lines':
                        return {
                            chart: {
                                spacingLeft: 0,
                                spacingRight: 0,
                                style: {
                                    fontFamily: 'Frutiger LT W02_45 Light, Times, Calibri, Helvetica, sans-serif'
                                }
                            },
                            title: {
                                style: {
                                    display: 'none'
                                }
                            },
                            subtitle: {
                                style: {
                                    display: 'none'
                                }
                            },

                            legend: {
                                useHTML: true,
                                itemStyle: {
                                    "color": "#333333",
                                    "cursor": "pointer",
                                    "fontSize": "12px",
                                    "fontWeight": "normal",
                                    "textOverflow": "ellipsis"
                                }
                            },
                            xAxis: {
                                categories: dataXAxisLines
                            },
                            yAxis: {
                                title: {
                                    text: dataYAxis
                                }
                            },
                            tooltip: tooltip_line,
                            colors: colorsLines,
                            series: dataLines,
                            credits: {
                                enabled: false
                            }
                        };
                        break;
                    case 'table':
                        var tableArrows = $('<div class="scroll-button scroll-left hidden" style="display: block;"></div><div class="scroll-button scroll-right" style="display: block;"></div>');
                        var tableWrapper = $('<div class="table-content"></div>');
                        var tableCeWrapper = $('<div class="ce-table"></div>');
                        var table = $('<table class="contenttable"></table>');

                        var header = $('<thead><tr></tr></thead>');
                        header.children().append('<th>' + dataYAxis + '</th>');

                        $.each(dataXAxisLines, function ($index, $value) {
                            var textColor = '';
                            if ($index == colors.length - 1) textColor = ' color: #ffffff;';
                            header.children().append('<th class="right" style="background-color:' + colors[$index] + ';' + textColor + '">' + $value + '</th>');
                        });
                        table.append(header);

                        var body = $('<tbody></tbody>');
                        $.each(dataLines, function ($index, $value) {
                            var row = $('<tr></tr>').appendTo(body);
                            row.append('<td>' + $value.name + '</td>');

                            $.each($value.data, function ($index2, $value2) {
                                var decimal = dataDecimal[$index];
                                var fn = dataFootnotes[$index][$index2];
                                var y = $value2 + " ";
                                var wert = $value2.toFixed(decimal);
                                if (wert == 'NaN') wert = '';
                                // var wert = $value2;
                                // if (y.match(/\./)) {
                                // 	wert = $value2.toFixed(1);
                                // 	if (dataYAxis == "in %") wert = $value2.toFixed(1);
                                // }
                                if (fn) {
                                    //glob.debug(dataFootnotes[$index][$index2]);
                                    //glob.debug(dataFootnotes[$index - 1][$index2]);
                                    //glob.debug(dataFootnotes.length);
                                    //glob.debug($index);
                                    if ($index > 0 && $index2 > 0) {
                                        if (!(dataFootnotes[$index][$index2] == dataFootnotes[$index - 1][$index2])) {
                                            var fnIndex = parseFloat($('.chart-footnotes p sup').last().text()) + 1;
                                        } else {
                                            var fnIndex = parseFloat($('.chart-footnotes p sup').last().text());
                                        }
                                    } else {
                                        var fnIndex = parseFloat($('.chart-footnotes p sup').last().text());
                                    }

                                    if (!$.isNumeric(fnIndex)) fnIndex = 1;
                                    if ($index > 0 && $index2 > 0) {
                                        if (!(dataFootnotes[$index][$index2] == dataFootnotes[$index - 1][$index2])) {
                                            $('.chart-footnotes').children('p').append('<sup>' + fnIndex + '</sup> ' + fn + '<br/>');
                                        }
                                    } else {
                                        $('.chart-footnotes').children('p').append('<sup>' + fnIndex + '</sup> ' + fn + '<br/>');

                                    }
                                    row.append('<td class="right">' + numberFormat(wert) + ' <sup>' + fnIndex + '</sup></td>');
                                } else {
                                    row.append('<td class="right">' + numberFormat(wert) + '</td>');
                                }
                            });
                            body.append(row);
                        });
                        table.append(body);

                        tableWrapper.append(table);
                        // TODO: Arrow Initialising
                        // tableCeWrapper.append(tableArrows);
                        tableCeWrapper.append(tableWrapper);

                        return tableCeWrapper;
                        break;
                }
            }
        }
    };

    portfolioHack = {
        init: function () {
            var portfolio = $('body.annual-report .element-mask_stage_slider');

            if (portfolio.length > 0) {
                $(portfolio).parents('body').addClass('portfolio');
            }

        }
    };

    hashDelete = {
        init: function () {

            var timeline = $('.element-mask_html-partial_timeline');

            if ($(timeline).length > 0) {

                $(timeline).find('a').each(function (index) {
                    var originalURL = $(this).attr('href');

                    var alteredURL = removeParam("cHash", originalURL);

                    $(this).attr("href", alteredURL + "&no_cache=1");

                })

                function removeParam(key, sourceURL) {
                    var rtn = sourceURL.split("?")[0],
                        param,
                        params_arr = [],
                        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
                    if (queryString !== "") {
                        params_arr = queryString.split("&");
                        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                            param = params_arr[i].split("=")[0];
                            if (param === key) {
                                params_arr.splice(i, 1);
                            }
                        }
                        rtn = rtn + "?" + params_arr.join("&");
                    }
                    return rtn;
                }

            }

        }


    };
    ogb20 = {
        init: function () {
            if ($('.element-mask_ogb20_header').hasClass('container')) {
                $('.element-mask_ogb20_header').removeClass('container');
                $('.element-mask_ogb20_highlights').removeClass('container');
                $('.element-mask_ogb20_article').removeClass('container');
                $('.element-mask_ogb20_facts').removeClass('container');
                $('.element-mask_ogb20_button').removeClass('container');

                $('.ogb20_button').each(function () {
                    $(this).parent().addClass($(this).data('color'))
                })

                $('.ogb20_article').each(function () {
                    if ($(this).hasClass('bgblue'))
                        $(this).parent().addClass('blue');
                })

            }
        }
    };

    ogb18Scrollto = {
        init: function () {

            var ogb18Ancor = $('.obg-header .tx_mpmjobapplication_applicationform .tile a, .element-mask_ogb18_infocircle .key-figures a');

            $(ogb18Ancor).on('click', function (e) {
                e.preventDefault();
                var ancorSelect = $(this).attr('href');

                $('html, body').animate({
                    scrollTop: ($(ancorSelect).offset().top - 100)
                }, 1500);
            })
        }
    };

    languageSwitch = {

        init: function () {
            const toggleButton = $('.icon-globe');
            const dropdown = $('.langDropdown')

            $(toggleButton).click(function () {
                $(dropdown).toggleClass('active')
            })
        }

        /*container: glob.doc.find('.navi-top-buttons .button-lg-switch'),
        trigger: undefined,
        content: undefined,

        blocked: false,

        animationSpeed: 200,

        show: function () {
            var self = this;

            self.blocked = true;

            self.trigger.fadeOut(self.animationSpeed, function () {
                self.content.fadeIn(self.animationSpeed, function () {
                    self.blocked = false;
                });
            });
        },

        hide: function () {
            var self = this;

            self.blocked = true;

            self.content.fadeOut(self.animationSpeed, function () {
                self.trigger.fadeIn(self.animationSpeed, function () {
                    self.blocked = false;
                });
            });
        },

        isVisible: function () {
            var self = this;

            visibility = false;

            if (self.content.is(':visible')) {
                visibility = true;
            }

            return visibility;
        },

        init: function () {
            var self = this;

            self.state = false;

            this.trigger = this.container.find('> a');
            this.content = this.trigger.siblings('.lg-switch');

            $('.navi-top-buttons .button-lg-switch a.active').click(function (e) {
                e.preventDefault();
            });

            self.trigger.click(function () {
                if (self.isVisible() || self.blocked) {
                    return false;
                }

                self.show();
            });

            $(document).mouseup(function (e) {
                if (!self.isVisible() || self.blocked) {
                    return false;
                }

                if (
                    // element blacklist
                    !$(e.target).is('.navi-top-buttons, .navi-top-buttons > .button-search a, .navi-search-wrap, navi-search-wrap *, .navi-top-search-bar, .navigation .navi-search-wrap input, navi-top-search-bar > input, .button-lg-switch, .button-lg-switch a, .lg-switch')
                    // element whitelist
                    || $(e.target).is('html, body')
                ) {
                    self.hide();
                }
            });


            var parameter = window.location.search;
            var newsPage = $('body#p-126');

            if (parameter && $(newsPage).length > 0) {
                $('.lg-switch a').each(function () {
                    var url = $(this).attr('href');
                    $(this).attr('href', url + parameter);
                });


            }


        }*/

    };

    searchBar = {
        init: function () {
            const trigger = $('.icon-search');
            const searchBar = $('.navi-search-wrap');
            const input = $(searchBar).find('input');
            const form = $('form.tx_indexedsearch-hidden');
            const formInput = $(form).find('input.tx-indexedsearch-searchbox-sword')

            console.log(searchBar);
            $(trigger).click(function () {
                searchBar.toggleClass('active')
                input.focus();
            })

            searchBar.keyup(function (e) {
                if (e.keyCode !== 13) {
                    return false;
                } else {
                    const val = input.val();
                    formInput.val(val);
                    form.submit();
                }
            });
        }

        /*
                trigger: glob.doc.find('.navi-top-buttons .button-search > a'),
                content: glob.doc.find('.navigation .navi-search-wrap'),
                input: glob.doc.find('.navigation .navi-search-wrap input'),
        
                blocked: false,
        
                animationSpeed: 400,
        
                show: function () {
                    var self = this;
        
                    self.blocked = true;
        
                    self.trigger.removeClass('icon-search');
                    self.trigger.addClass('icon-cross');
        
                    self.content.fadeIn(self.animationSpeed, function () {
                        self.input.focus();
                        self.blocked = false;
                    });
                },
        
                hide: function () {
                    var self = this;
        
                    self.blocked = true;
        
                    self.trigger.removeClass('icon-cross');
                    self.trigger.addClass('icon-search');
        
                    self.content.fadeOut(self.animationSpeed, function () {
                        self.blocked = false;
                    });
                },
        
                isVisible: function () {
                    var self = this;
        
                    visibility = false;
        
                    if (self.content.is(':visible')) {
                        visibility = true;
                    }
        
                    return visibility;
                },
        
                submitSearchForm: function () {
                    var self = this;
        
                    var searchWord = self.input.val();
                    var form = $('form.tx_indexedsearch-hidden');
        
                    form.find('input.tx-indexedsearch-searchbox-sword').val(searchWord);
                    form.submit();
                },
        
                init: function () {
                    var self = this;
        
                    self.state = false;
        
                    self.trigger.click(function () {
                        if (self.isVisible() || self.blocked) {
                            return false;
                        }
        
                        self.input.val('');
        
                        self.show();
                    });
        
                    $(document).mouseup(function (e) {
                        if (!self.isVisible() || self.blocked) {
                            return false;
                        }
        
                        if (
                            // element blacklist
                            !$(e.target).is('.navi-top-buttons, .navi-top-buttons > .button-lg-switch a, .navi-top-search-bar, .navi-top-search-bar input')
                            // element whitelist
                            || $(e.target).is('html, body')
                        ) {
                            self.hide();
                        }
                    });
        
                    self.content.keyup(function (e) {
                        // Enter key
                        if (e.keyCode !== 13) {
                            return false;
                        }
        
                        self.submitSearchForm();
                    });
                }*/
    };

    subMenus = {
        animationSpeed: 200,

        mainNaviLinks: $('.navigation .main-menu > li:not(#pl-316,#pl-575) > a'),
        submenuNaviLinks: $('.navigation .main-menu > li > .submenu > li > a'),


        getSubMenuByLink: function (link, subClass) {
            if (subClass === undefined) {
                subClass = 'submenu';
            }

            var subMenu = $(link).siblings('ul.' + subClass);

            return subMenu;
        },

        getLinkBySubMenu: function (subMenu) {
            var link = $(subMenu).siblings('a');

            return link;
        },

        getParentSubMenu: function (thirdLevelSubMenu) {
            return $(thirdLevelSubMenu).parents('.submenu');
        },

        resetMenuSize: function (menu) {
            $(menu).css('width', 'auto');
        },

        resizeSubMenu: function (subMenu) {
            var self = this;

            $(subMenu).css('width', 'auto');

            if (!$(subMenu).data('original-width')) {
                $(subMenu).data('original-width', $(subMenu).width());
            }

            var originalWidth = $(subMenu).data('original-width');

            $(subMenu).css('width', originalWidth);
            $(subMenu).css('min-width', self.getLinkBySubMenu(subMenu).width());
        },

        moveSubMenu: function (subMenu) {
            return true;
            var self = this;

            if (!$(subMenu).hasClass('submenu') && $(subMenu).parents('.submenu').length > 0) {
                subMenu = $(subMenu).parents('.submenu');
            }

            var subMenuWidth = $(subMenu).width();

            var link = self.getLinkBySubMenu(subMenu);
            var linkWidth = $(link).width();

            var x = $(link).parents('li').offset().left;
            var xr = x + linkWidth;

            var windowCenter = $(window).width() / 2;

            if (x >= windowCenter) {
                x = xr - subMenuWidth;
            }

            subMenu.css('left', x);
        },

        showSubMenu: function (link) {
            var self = this;
            var subMenu = self.getSubMenuByLink(link);

            if (subMenu.length !== 0) {
                self.resizeSubMenu(subMenu);
                self.moveSubMenu(subMenu);

                subMenu.fadeIn(self.animationSpeed);
            }
        },

        showThirdLevelMenu: function (menu) {
            menu.slideDown(self.animationSpeed);
        },

        hideThirdLevelMenu: function (menu, $callback) {
            menu.slideUp(self.animationSpeed, $callback);
            menu.siblings('.submenu-trigger.triggered').removeClass('triggered');
            menu.siblings('a.submenu-active').removeClass('submenu-active');
        },

        hideSubMenus: function () {
            var menus = $('.submenu, .submenu-level-3');
            menus.hide();
            menus.find('.submenu-trigger.triggered').removeClass('triggered');
        },

        collapseMenus: function () {
            this.mainNaviLinks.removeClass('submenu-active').blur();
            $('.submenu, .submenu-level-3').fadeOut(self.animationSpeed);
        },

        menuLinkHandler: function (config) {
            var self = this;
            var link = config.link;
            var subMenu = self.getSubMenuByLink(link, config.subMenuClass);

            if ($(subMenu).length === 0) {
                self.collapseMenus();
                return true;
            }

            if ($(link).hasClass('submenu-active')) {
                if (subMenu.length !== 0) {
                    config.event.preventDefault();

                    self.collapseMenus();
                }

                return true;
            }

            config.event.preventDefault();

            $(self.mainNaviLinks).removeClass('submenu-active');
            $(self.submenuNaviLinks).removeClass('submenu-active');
            $(link).addClass('submenu-active');

            self.hideSubMenus();
            self.showSubMenu(link);
        },

        subMenuLinkHandler: function (config) {
            var self = this;
            var link = config.link;
            var subMenu = self.getSubMenuByLink(link, config.subMenuClass);
            var parentMenu = self.getParentSubMenu(subMenu);

            if ($(link).hasClass('submenu-active')) {
                if (subMenu.length !== 0) {
                    config.event.preventDefault();

                    $(link)
                        .removeClass('submenu-active')
                        .blur();

                    self.hideThirdLevelMenu(subMenu, function () {
                        self.moveSubMenu(parentMenu);
                    });
                }

                return true;
            }

            config.event.preventDefault();

            $(link).addClass('submenu-active');

            self.hideThirdLevelMenu($('.submenu-level-3').not(subMenu), function () {
                self.moveSubMenu(parentMenu);
            });

            self.resetMenuSize(parentMenu);
            self.showThirdLevelMenu(subMenu);
            self.moveSubMenu(parentMenu);
        },

        init: function () {
            var self = this;

            self.mainNaviLinks.on('click', function (e) {
                self.menuLinkHandler({
                    event: e,
                    link: this,
                    subMenuClass: 'submenu',
                });
            });

            self.submenuNaviLinks.siblings('.submenu-trigger').on('click', function (e) {
                $(this).toggleClass('triggered');

                self.subMenuLinkHandler({
                    event: e,
                    link: $(this).siblings('a').get(0),
                    subMenuClass: 'submenu-level-3',
                });
            });

            $(document).mouseup(function (e) {
                if (
                    // element blacklist
                    !$(e.target).is('.navigation ul li, .navigation ul li a, .submenu-trigger, ul.submenu-level-3')
                    // element whitelist
                    || $(e.target).is('html, body')
                ) {
                    self.collapseMenus();
                }
            });
        }
    };

    ogbCount = {
        init: function () {

            /**
             * jQuery scroroller Plugin 1.0
             *
             * http://www.tinywall.net/
             *
             * Developers: Arun David, Boobalan
             * Copyright (c) 2014
             */
            (function ($) {
                $('.numscroller').removeClass('isShown');

                $(window).on("load", function () {
                    $(document).scrollzipInit();
                    $(document).rollerInit();
                });
                $(window).on("load scroll resize", function () {
                    $('.numscroller').scrollzip({
                        showFunction: function () {
                            numberRoller($(this).attr('data-slno'));
                        },
                        wholeVisible: false,
                    });
                });
                $.fn.scrollzipInit = function () {
                    $('body').prepend("<div style='position:fixed;top:0px;left:0px;width:0;height:0;' id='scrollzipPoint'></div>");
                };
                $.fn.rollerInit = function () {
                    var i = 0;
                    $('.numscroller').each(function () {
                        i++;
                        $(this).attr('data-slno', i);
                        $(this).addClass("roller-title-number-" + i);
                    });
                };
                $.fn.scrollzip = function (options) {
                    var settings = $.extend({
                        showFunction: null,
                        hideFunction: null,
                        showShift: 0,
                        wholeVisible: false,
                        hideShift: 0,
                    }, options);
                    return this.each(function (i, obj) {
                        $(this).addClass('scrollzip');
                        if ($.isFunction(settings.showFunction)) {
                            let scrollZipTop = $(window).scrollTop();

                            if (
                                !$(this).hasClass('isShown') &&
                                ($(window).outerHeight() + scrollZipTop - settings.showShift) > ($(this).offset().top + ((settings.wholeVisible) ? $(this).outerHeight() : 0)) &&
                                (scrollZipTop + ((settings.wholeVisible) ? $(this).outerHeight() : 0)) < ($(this).outerHeight() + $(this).offset().top - settings.showShift)
                            ) {
                                $(this).addClass('isShown');
                                settings.showFunction.call(this);
                            }
                        }
                        if ($.isFunction(settings.hideFunction)) {
                            if (
                                $(this).hasClass('isShown') &&
                                (($(window).outerHeight() + scrollZipTop - settings.hideShift) < ($(this).offset().top + ((settings.wholeVisible) ? $(this).outerHeight() : 0)) ||
                                    (scrollZipTop + ((settings.wholeVisible) ? $(this).outerHeight() : 0)) > ($(this).outerHeight() + $(this).offset().top - settings.hideShift))
                            ) {
                                $(this).removeClass('isShown');
                                settings.hideFunction.call(this);
                            }
                        }
                        return this;
                    });
                };

                function numberRoller(slno) {
                    var min = $('.roller-title-number-' + slno).attr('data-min');
                    var max = $('.roller-title-number-' + slno).attr('data-max');
                    var timediff = $('.roller-title-number-' + slno).attr('data-delay');
                    var increment = $('.roller-title-number-' + slno).attr('data-increment');
                    var numdiff = max - min;
                    var timeout = (timediff * 1000) / numdiff;
                    //if(numinc<10){
                    //increment=Math.floor((timediff*1000)/10);
                    //}//alert(increment);
                    numberRoll(slno, min, max, increment, timeout);

                }

                function numberRoll(slno, min, max, increment, timeout) {//alert(slno+"="+min+"="+max+"="+increment+"="+timeout);
                    if (min <= max) {
                        $('.roller-title-number-' + slno).html(min);
                        min = parseInt(min) + parseInt(increment);
                        setTimeout(function () {
                            numberRoll(eval(slno), eval(min), eval(max), eval(increment), eval(timeout))
                        }, timeout);
                    } else {
                        $('.roller-title-number-' + slno).html(max);
                    }
                }
            })($);
        }
    };

    naviHideHack = {
        init: function () {
            var selector = '#p-150';
            var element = $(selector);

            ///// auskommentiert da unklar ist warum es drin ist
            // element
            //     .removeClass('has-subpages')
            //     .find('.submenu-trigger').remove();

        }
    };

    naviAnchorHack = {
        getIdByHref: function (href) {
            var pattern = /^.*#[a-zA-Z\d]+$/;
            var id = false;

            if (href.match(pattern)) {
                var idPos = href.search('#');

                if (idPos > 0) {
                    id = href.substr(idPos);
                }
            }

            return id;
        },

        isValidId: function (id) {
            if (!(typeof id === 'string') && !(id instanceof String)) {
                return false;
            }

            var blacklist = [
                '#myCarousel',
            ];

            if (blacklist.includes(id)) {
                return false;
            }

            if ($(id).length < 1) {
                return false;
            }

            return true;
        },

        linkHandler: function (event) {
            var self = naviAnchorHack;
            var href = $(this).prop('href');
            var id = self.getIdByHref(href);

            if (self.isValidId(id)) {
                self.scrollToId(id);
            }
        },

        scrollToId: function (id) {
            var offset = $(id).offset().top;
            offset -= $('.navigation .navi-wrap').height();
            offset -= 15; // a little extra

            $('html, body').animate({
                scrollTop: offset
            }, 500);
        },

        init: function () {
            $(document).on('click', 'a', this.linkHandler);
        }
    };

    powermailScrollto = {
        init: function () {

            /*var pwMail = $('.tx-powermail');


            function scrollError() {
                if ($('.tx-powermail .parsley-required').length > 0) {
                    $('html, body').animate({
                        scrollTop: ($('.parsley-required').offset().top -100)
                    },1500);
                }
            }
            scrollError();
            
            $(pwMail).find('input[type=submit]').on('click', function(e) {
                scrollError();
            })*/
        }
    };


    totop = {
        init: function () {

            var totop = $('.totop');

            if ($(totop).length > 0) {


                $(window).on("scroll", function () {
                    if ($(this).scrollTop() > 520) {
                        $(totop).fadeIn();
                    } else {
                        $(totop).stop().fadeOut();
                    }
                });


                $(totop).on('click', function () {
                    $("html, body").animate({ scrollTop: 0 }, "slow");
                })
            }

        }
    };

    ogb19Sidebar = {
        init: function () {

            function Sidebar() {
                var elWidth = $('.sidebar').find('li').width();
                $('.sidebar').find('li').height(elWidth);
                $('.sidebar').find('.subpage').height(0);
                $('.sidebar').find('.subpage ').height(0);
            }

            function SidebarHeight() {
                var fullHeight = 0;
                $(height).each(function () {
                    var elHeight = $(this).height()
                    fullHeight = fullHeight + elHeight;
                });
                $('.sidebar').css('height', fullHeight);
            }

            $(window).resize(function () {
                Sidebar();
            });
            Sidebar();

            $('.sidebar .sub').hover(function () {
                $(this).next('ul').find('li').stop().animate({
                    height: $(this).width()
                });
            },
                function () {
                    $(this).next('ul').find('li').stop().animate({
                        height: 0
                    });
                });

            $('.sidebar .subpage').hover(function () {
                $(this).parent().find('li').stop().animate({
                    height: $(this).width()
                });
            },
                function () {
                    $(this).parent().find('li').stop().animate({
                        height: 0
                    });
                });

            $('.sidebar-mobile .split').click(function () {
                $(this).parent().find('>ul').slideToggle();
                $(this).toggleClass('toggle');
            });

            var height = $('.sidebar li');


            var element = $('.sidebar .sub span'),
                string = 'Chancen in der Automobilzulieferindustrie';
            $(element).each(function () {
                if ($(this).text() === string) {
                    $(this).html('Chancen in der Automobil- zulieferindustrie')
                }
            });
            if ($(window).width() < '420') {
                var otherElement = $('.ogb19header h3'),
                    otherstring = 'Chancen in der Automobilzulieferindustrie';
                $(otherElement).each(function () {
                    if ($(this).text() === otherstring) {
                        $(this).html('Chancen in der Automobil- zulieferindustrie')
                    }
                });
            }

            var activeImage = $('.sidebar .is-current img');

            if (activeImage.length) {
                var src = $(activeImage).attr('src'),
                    res = src.split("."),
                    newSrc = res[0] + '-white.' + res[1];
                activeImage.attr('src', newSrc)
            }
            $('.main-menu .has-subpages a').each(function () {

                if ($(this).html() === 'Geschäftsbericht 2018/2019') {
                    $(this).parent().find('span').css('display', 'none');
                }
                if ($(this).html() === 'Annual Report 2018/2019') {
                    $(this).parent().find('span').css('display', 'none');
                }
            });
            $('.canvas-menu a').each(function () {
                if ($(this).html() === '<span class="split more" data-icon="I"></span>Geschäftsbericht 2018/2019') {
                    $(this).find('.more').css('display', 'none');
                }
                if ($(this).html() === '<span class="split more" data-icon="I"></span>Annual Report 2018/2019') {
                    $(this).find('.more').css('display', 'none');
                }
            })
        }
    };
    Newsroom = {
        init: function () {

            var
                $grid = $('.newsroom-grid').isotope({
                    itemSelector: '.grid-item',
                    layoutMode: 'masonry',
                });

            //Part of logic where stuff gets selected by url (for example if we link from another site to a specific news category)

            var urlToCheck = window.location.href;
            var regexToCheckForAndIsolateNewsroomCategeroyURLParameter = new RegExp("selectNewsCategory=.*&c");
            var extractedCategoryParamFromURL;
            if (regexToCheckForAndIsolateNewsroomCategeroyURLParameter.test(urlToCheck)) {
                extractedCategoryParamFromURL = regexToCheckForAndIsolateNewsroomCategeroyURLParameter.exec(urlToCheck);
                extractedCategoryParamFromURL = extractedCategoryParamFromURL.toString();
                extractedCategoryParamFromURL = extractedCategoryParamFromURL.substring(19, (extractedCategoryParamFromURL.length - 2));
                //Special case to rename the param for Ad-hoc News as this is not consistently named across the system
                extractedCategoryParamFromURL = "." + extractedCategoryParamFromURL;

                $grid.isotope({ filter: '' + '' + extractedCategoryParamFromURL });
                $('.categorieList button').removeClass('is-checked');
                $('.categorieList button' + extractedCategoryParamFromURL).addClass('is-checked');
            } else {
                //We do nothing
            }


            if ($grid.length > 0) {


                $('.categorieList').on('click', 'button', function () {
                    $('.categorieList button').removeClass('is-checked');
                    $(this).addClass('is-checked');
                    var filterValueYear = $('.yearFilter').attr('data-year');
                    var filterValueCategory = $(this).attr('data-filter');
                    $grid.isotope({ filter: filterValueYear + '' + filterValueCategory });
                    loadMore(initShow);
                });

                $('.yearFilter').on('change', function () {
                    // get filter value from option value
                    var filterValueYear = this.value;
                    $(this).attr('data-year', filterValueYear)
                    var filterValueCategory = $('.categorieList .is-checked').attr('data-filter');

                    $grid.isotope({ filter: filterValueYear + '' + filterValueCategory });
                    loadMore(initShow);
                });

                //****************************
                // Isotope Load more button
                //****************************
                var initShow = 10; //number of items loaded on init & onclick load more button
                var counter = initShow; //counter for load more button
                var iso = $grid.data('isotope'); // get Isotope instance

                loadMore(initShow); //execute function onload

                function loadMore(toShow) {


                    var hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function (item) {
                        return item.element;
                    });
                    $grid.find(".hidden").removeClass("hidden");
                    $(hiddenElems).addClass('hidden');
                    $grid.isotope('layout');

                    //when no more to load, hide show more button
                    if (hiddenElems.length == 0) {
                        jQuery("#load-more").hide();
                    } else {
                        jQuery("#load-more").show();
                    };
                }
                //when load more button clicked
                $("#load-more").click(function () {
                    if ($('#filters').data('clicked')) {
                        //when filter button clicked, set initial value for counter
                        counter = initShow;
                        $('#filters').data('clicked', false);
                    } else {
                        counter = counter;
                    }
                    counter = counter + initShow;
                    loadMore(counter);
                });

                //when filter button clicked


                var currentYear = (new Date).getFullYear(),
                    yearfilter = $('.yearFilter'),
                    firstYearOption = $(yearfilter).find('.year'),
                    all = $(yearfilter).find('.all'),
                    firstYear = $(firstYearOption).text();

                for (var i = firstYear; i <= currentYear; i++) {
                    $(yearfilter).prepend('<option class="year" value=".' + i + '">' + i + '</option>')
                }
                $(yearfilter).prepend(all)
                $(firstYearOption).last().remove()
            }
            //Home Teaser
            var item = $('.news-menu-view .item'),
                secondItem = $('.news-menu-view .margin-top'),
                negativeMargin = $('.news-menu-view .negativ-margin-top'),
                itemWidth = $(item).width(),
                itemWidthHalf = itemWidth / 2;

            $(item).css('height', itemWidth)
            $(secondItem).css('margin-top', itemWidthHalf)
            $(negativeMargin).css('margin-top', Math.abs(itemWidthHalf) * -1)

        }
    };

    NewsroomFilterUrl = {
        init: function () {
            if ($('.Newsroom').length) {
                const url = location.href
                const split = url.split("#")
                if (split.length > 1) {
                    const type = '.hash-' + split[1]
                    $(type).click();
                }
            }
        }
    };

    downloadHoverTextInjection = {
        init: function () {
            var downloadHoverTextEnglish = "Initiates file download.";
            var downloadHoverTextGerman = "Leitet Herunterladen der Datei ein.";
            var websiteLanguage = $('html').attr('lang');
            if (websiteLanguage == null) {
                //don't manipulate the a element
            } else if (websiteLanguage == 'de') {
                $('a.download').prop('title', downloadHoverTextGerman);
            } else if (websiteLanguage == 'en') {
                $('a.download').prop('title', downloadHoverTextEnglish);
            }
        }
    };

    SidebarNavigation = {
        init: function () {
            const elements = $('[data-nav]')
            const sidebar = $('#sidebar, #sidebar-alternative')
            const sidebarHeader = $('.sidebarHeaderCol').find(sidebar)
            if ($(sidebar).length) {
                $(elements).each(function () {
                    let title = $(this).data('nav');
                    let id = $(this).attr('id');
                    sidebar.append('<li class="py-2 lvl1 d-flex flex-wrap"><a href="#' + id + '">' + title + '</a></li>');

                    //add slideTolinks also to mobile hamburger menu
                    let hamburgerMenu = $('.navigation-mobile .page-navigation .active').nextAll('.sub');
                    hamburgerMenu.append('<li class="py-2 lvl1"><a href="#' + id + '" class="closeMenuTrigger">' + title + '</a></li>');
                })

                $('.closeMenuTrigger').click(function () {
                    $('.hamburger').trigger('click');
                });

                if (sidebarHeader.length > 0) {
                    const sidebarTimeline = gsap.timeline({
                        scrollTrigger: {
                            trigger: '.gsap-container',
                            start: 'top =+50px',
                            end: 'bottom =+550px',
                            pin: sidebar,
                            toggleActions: "play none reverse none"
                        }
                    });
                } else {
                    const sidebarTimeline = gsap.timeline({
                        scrollTrigger: {
                            trigger: '.contentcol',
                            start: 'top 200px',
                            end: 'bottom =+400px',
                            pin: sidebar,
                            toggleActions: "play none reverse none"
                        }
                    });
                }
            }
        }
    };
    FactContentBox = {
        init: function () {
            const slider = $('.facts-items-slider');
            const sliderDesktopItems = $(slider).data('desktopitems');
            $(slider).slick({
                slidesToShow: sliderDesktopItems,
                slidesToScroll: 1,
                autoplaySpeed: 2000,
                arrows: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: true,
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            arrows: true,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    };
    PortfolioFacts = {
        init: function () {
            const slider = $('.slick-portfolio-facts-slider');
            const sliderDesktopItems = $(slider).data('desktopitems');
            $(slider).slick({
                slidesToShow: sliderDesktopItems,
                slidesToScroll: sliderDesktopItems,
                autoplaySpeed: 2000,
                variableWidth: true,
                arrows: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            arrows: true,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    };
    PortfolioTeaser = {
        init: function () {
            $('.slick-portfolio-teaser').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplaySpeed: 3000,
                arrows: true,
                dots: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: true,
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            arrows: true,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    };
    IndustryDistribution = {
        init: function () {
            const slider = $('.slick-industry-distribution-slider')
            $(slider).slick({
                slidesToShow: 6,
                slidesToScroll: 6,
                autoplaySpeed: 2000,
                dots: false,
                arrows: true,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            arrows: true,
                            slidesToShow: 5,
                            slidesToScroll: 1,

                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: true,
                            slidesToShow: 3,
                            slidesToScroll: 1,

                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            arrows: true,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
            const dots = $(slider).find('.slick-dots');
            const dotsAmount = $(dots).find('li').length;

            if (dotsAmount <= 1) {
                dots.remove();
            }
        }

    };
    IconSlider = {
        init: function () {
            const slider = $('.icon-slider-items-slider');
            const sliderDesktopItems = $(slider).data('desktopitems');
            $(slider).slick({
                slidesToShow: sliderDesktopItems,
                slidesToScroll: 1,
                autoplaySpeed: 2000,
                arrows: true,
                dots: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: true,
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            arrows: true,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
            const dots = $(slider).find('.slick-dots');
            const dotsAmount = $(dots).find('li').length;

            if (dotsAmount <= 1) {
                dots.remove();
            }
        }
    };
    PublicationSlider = {
        init: function () {
            const slider = $('.slider_publications .slider');
            $(slider).slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplaySpeed: 2000,
                arrows: true,
                dots: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: true,
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            arrows: true,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    };
    SliderSuccessStories = {
        init: function () {
            const slider = $('.success-stories-items-slider');
            if ($(slider).length) {

                $(slider).slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplaySpeed: 2000,
                    arrows: true,
                    dots: false,

                    responsive: [{
                        breakpoint: 768,
                        settings:
                        {
                            arrows: false,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                    ]
                });
            }

        }
    };
    NewsListCarousel = {
        init: function () {
            const newsCarousel = $('.newsCarousel');
            if ($(newsCarousel).length > 0) {
                $(newsCarousel).parents('.element-news_pi1').addClass('news-list-carousel');
                $(newsCarousel).find($('.carousel-item', '.show-neighbors')).each(function () {
                    let next = $(this).next();
                    if (!next.length) {
                        next = $(this).siblings(':first');
                    }
                    next.children(':first-child').clone().appendTo($(this));
                }).each(function () {
                    let prev = $(this).prev();
                    if (!prev.length) {
                        prev = $(this).siblings(':last');
                    }
                    prev.children(':nth-last-child(2)').clone().prependTo($(this));
                });
            }
        }
    };

    applicationForm = {
        init: function () {
            const applicationForm = $('.layout_application_process');

            if ($(applicationForm).length > 0) {
                $('.add-upload').on('click', function (e) {
                    e.preventDefault();
                    let allElemsVisible = true;

                    $('.optional_upload').each(function (i, elem) {
                        if ($(elem).css('display') == 'none') {
                            $(elem).css('display', 'flex');
                            return false;
                        }
                    });

                    $('.optional_upload').each(function (i, elem) {
                        if ($(elem).css('display') == 'none') {
                            allElemsVisible = false;
                            return false;
                        }
                    });

                    if (allElemsVisible) {
                        $('.add-upload').hide();
                    } else {
                        $('.add-upload').show();
                    }
                });

                $('.remove-upload').on('click', function (e) {
                    e.preventDefault();
                    $(this).parents('.optional_upload').hide();
                    if ($('.add-upload').css('display') == 'none')
                        $('.add-upload').show();
                });
            }
        }
    };

})(window, window.document, __dbagJq);


if (document.getElementById('p-1225')) {
    const submitButton = document.getElementById("submit_marker_02");
    const anschreiben = document.getElementById("powermail_field_anschreiben");
    const lebenslauf = document.getElementById("powermail_field_lebenslauf");
    const abi = document.getElementById("powermail_field_abiturzeugnis");
    const weitereZeugnisse = document.getElementById("powermail_field_weiterezeugnisse");
    const weitereUnterlagen1 = document.getElementById("powermail_field_weitereunterlagen");
    const weitereUnterlagen2 = document.getElementById("powermail_field_weitereunterlagen_01");
    const weitereUnterlagen3 = document.getElementById("powermail_field_weitereunterlagen_02");
    const weitereUnterlagen4 = document.getElementById("powermail_field_weitereunterlagen_03");
    const weitereUnterlagen5 = document.getElementById("powermail_field_weitereunterlagen_04");

    const maxSize = anschreiben.getAttribute('data-powermail-powermailfilesize').replace(",anschreiben", '') / 1024 / 1024;
    let totalSize = 0;
    let remainingSize = maxSize;
    const sizeCounter = document.getElementById('file_size_counter');
    sizeCounter.innerHTML = (remainingSize - totalSize);

    const sizeError = document.getElementById('file_size_error');

    let sizeAnschreiben = 0;
    let sizeLebenslauf = 0;
    let sizeAbi = 0;
    let sizeWeitereZeugnisse = 0;
    let sizeWeitereUnterlagen1 = 0;
    let sizeWeitereUnterlagen2 = 0;
    let sizeWeitereUnterlagen3 = 0;
    let sizeWeitereUnterlagen4 = 0;
    let sizeWeitereUnterlagen5 = 0;

    anschreiben.onchange = function () {
        sizeAnschreiben = this.files[0].size;
        document.getElementById('file_name_anschreiben').innerHTML = this.value.replace(/C:\\fakepath\\/i, '');
        checkTotalFileSize();
    };
    lebenslauf.onchange = function () {
        sizeLebenslauf = this.files[0].size;
        document.getElementById('file_name_lebenslauf').innerHTML = this.value.replace(/C:\\fakepath\\/i, '');
        checkTotalFileSize();
    };
    abi.onchange = function () {
        sizeAbi = this.files[0].size;
        document.getElementById('file_name_abiturzeugnis').innerHTML = this.value.replace(/C:\\fakepath\\/i, '');
        checkTotalFileSize();
    };
    weitereZeugnisse.onchange = function () {
        sizeWeitereZeugnisse = this.files[0].size;
        document.getElementById('file_name_weiterezeugnisse').innerHTML = this.value.replace(/C:\\fakepath\\/i, '');
        checkTotalFileSize();
    };
    weitereUnterlagen1.onchange = function () {
        sizeWeitereUnterlagen1 = this.files[0].size;
        document.getElementById('file_name_weitereunterlagen').innerHTML = this.value.replace(/C:\\fakepath\\/i, '');
        checkTotalFileSize();
    };
    weitereUnterlagen2.onchange = function () {
        sizeWeitereUnterlagen2 = this.files[0].size;
        document.getElementById('file_name_weitereunterlagen_01').innerHTML = this.value.replace(/C:\\fakepath\\/i, '');
        checkTotalFileSize();
    };
    weitereUnterlagen3.onchange = function () {
        sizeWeitereUnterlagen3 = this.files[0].size;
        document.getElementById('file_name_weitereunterlagen_02').innerHTML = this.value.replace(/C:\\fakepath\\/i, '');
        checkTotalFileSize();
    };
    weitereUnterlagen4.onchange = function () {
        sizeWeitereUnterlagen4 = this.files[0].size;
        document.getElementById('file_name_weitereunterlagen_03').innerHTML = this.value.replace(/C:\\fakepath\\/i, '');
        checkTotalFileSize();
    };
    weitereUnterlagen5.onchange = function () {
        sizeWeitereUnterlagen5 = this.files[0].size;
        document.getElementById('file_name_weitereunterlagen_04').innerHTML = this.value.replace(/C:\\fakepath\\/i, '');
        checkTotalFileSize();
    };

    function checkTotalFileSize() {
        totalSize = (sizeAnschreiben + sizeLebenslauf + sizeAbi + sizeWeitereZeugnisse + sizeWeitereUnterlagen1 + sizeWeitereUnterlagen2 + sizeWeitereUnterlagen3 + sizeWeitereUnterlagen4 + sizeWeitereUnterlagen5) / 1000 / 1000;
        remainingSize = maxSize - totalSize;
        sizeCounter.innerHTML = remainingSize.toFixed(2);
        if ((totalSize) > maxSize) {
            submitButton.disabled = true;
            sizeError.style.setProperty('display', 'block', 'important');

        } else {
            submitButton.disabled = false;
            sizeError.style.setProperty('display', 'none', 'important');
        }
    }
}

var powermailReCaptcha = {
    captchaResponse: null,
    dictionary: null,
    locallang: {
        default: {
            required: 'This value is required!'
        },
        de: {
            required: 'Dieses Feld muss ausgefüllt werden!'
        }
    },
    init: function () {
        let $ctrl = this;
        window.addEventListener('load', function () {
            $ctrl.captchaResponse = document.getElementById('g-recaptcha-response');
            // break out if no recaptcha is present
            if (!$ctrl.captchaResponse)
                return;

            $ctrl.loadDictionary();
            $ctrl.bindEvents();
            $ctrl.insertParsleyAttributes();
        });
    },
    captchaCallback: function (fieldId, result) {
        let powermailFieldWrap = document.getElementById('powermail_fieldwrap_' + fieldId);
        if (powermailFieldWrap && result) {
            let parsleyErrorList = powermailFieldWrap.querySelector('.parsley-errors-list');
            parsleyErrorList.innerHTML = '';
        }
    },
    loadDictionary: function () {
        let $ctrl = this;
        if (document.querySelector('html').getAttribute('lang') != 'de')
            $ctrl.dictionary = $ctrl.locallang.default;
        else
            $ctrl.dictionary = $ctrl.locallang.de;
    },
    insertParsleyAttributes: function () {
        let $ctrl = this;
        $ctrl.captchaResponse.setAttribute('data-parsley-required-message', $ctrl.dictionary.required);
        $ctrl.captchaResponse.setAttribute('data-parsley-trigger', 'change');
    },
    bindEvents: function () {
        let $ctrl = this;
        $ctrl.captchaResponse.setAttribute("required", "required");
    }
};
powermailReCaptcha.init();


// Redesigned highchart for chart pie mask elements
var chartPie = {
    chartPies: null,
    size: 220, // size of pie (width and height)
    padding: 25, // padding arround pie
    legend: {
        align: 'center',
        verticalAlign: 'bottom',
        textPadding: 10,
        itemMargin: 5,
        symbolSize: 16,
        itemStyle: {
            color: "inherit",
            cursor: "pointer",
            fontSize: "inherit",
            fontWeight: "inherit",
        },
    },
    init: function () {
        let $ctrl = this;
        window.onload = function () {
            $ctrl.chartPies = document.getElementsByClassName('ce-piechart');
            if (!$ctrl.chartPies)
                return;
            $ctrl.initCharts();
        };
    },
    initCharts: function () {
        let $ctrl = this;

        if (!$ctrl.chartPies.length)
            return;

        let chartLegend = $ctrl.legend;

        for (i = 0; i < $ctrl.chartPies.length; i++) {

            let chartContainer = $ctrl.chartPies[i];

            // get data from container
            let chartLabels = JSON.parse(chartContainer.getAttribute('data-labels'));
            let chartValues = JSON.parse(chartContainer.getAttribute('data-values'));
            let chartColors = JSON.parse(chartContainer.getAttribute('data-colors'));
            let chartColorsFallback = JSON.parse(chartContainer.getAttribute('data-colors-fallback'));

            // representation of the percentages depends on the selected language
            let decimalPoint = chartContainer.getAttribute('data-decimal-seperator');
            let thousandsSep = chartContainer.getAttribute('data-number-seperator');


            let containerWidth = chartContainer.clientWidth;
            // if (containerWidth < 123) {
            //     chartLegend.temStyle.fontSize = '14px';
            //     chartLegend.symbolSize = 16;
            // }

            let legendItemHeight = (chartLegend.itemMargin * 2) + chartLegend.symbolSize;
            let legendHeight = (chartValues.length * legendItemHeight);

            // chart height includes the size of legend items
            let chartHeight = $ctrl.size + (5.5 * $ctrl.padding) + legendHeight;
            chartLegend.width = $ctrl.size + (2 * $ctrl.padding);
            chartLegend.y = -2 * $ctrl.padding;

            // set center position of pie (x, y)
            let plotCenter = ['50%', ($ctrl.size / 2) + $ctrl.padding];

            // show legend right next to the chart if screen is wide enough
            let legendPosition = chartContainer.getAttribute('data-legend');
            if (legendPosition == 1 && document.getElementsByTagName('html')[0].clientWidth >= 991) {
                chartLegend.align = 'right';
                chartLegend.verticalAlign = 'middle';
                chartLegend.width = containerWidth / 2 - $ctrl.padding;
                chartHeight = $ctrl.size + (3.5 * $ctrl.padding);
                chartLegend.y = -1 * $ctrl.padding;
                plotCenter = [
                    (containerWidth / 2) - (2 * $ctrl.padding) - ($ctrl.size / 2),
                    ($ctrl.size / 2) + $ctrl.padding
                ];
            }


            const chartData = [];
            for (x = 0; x < chartValues.length; x++) {
                chartData.push([chartLabels[x], chartValues[x]]);
            }

            // fill empty colors from fallback
            let fallbackKey = 0;
            for (x = 0; x < chartColors.length; x++) {
                if (chartColors[x])
                    continue;

                // set empty color to next fallback color
                chartColors[x] = chartColorsFallback[fallbackKey];

                // increase counter to next fallback color
                if (chartColorsFallback.length > (fallbackKey + 1)) {
                    fallbackKey++;
                } else {
                    fallbackKey = 0;
                }
            }

            // fall back to the default color set for elements previously defined without colors
            if (chartColors.length == 0) {
                chartColors = chartColorsFallback;
            }

            Highcharts.setOptions({
                colors: chartColors,
                chart: {
                    style: {
                        fontFamily: 'inherit',
                        fontSize: 'inherit'
                    }
                }
            });

            new Highcharts.Chart({
                legend: {
                    align: chartLegend.align,
                    verticalAlign: chartLegend.verticalAlign,
                    y: chartLegend.y, // distance over legend // 0 is middle of chart
                    layout: 'vertical',
                    symbolRadius: 0,
                    borderColor: '#000000',
                    symbolHeight: chartLegend.symbolSize,
                    symbolWidth: chartLegend.symbolSize,
                    itemMarginTop: chartLegend.itemMargin,
                    itemMarginBottom: chartLegend.itemMargin,
                    itemStyle: chartLegend.itemStyle,
                    symbolPadding: chartLegend.textPadding, // padding between symbol and text
                    width: chartLegend.width,
                    // backgroundColor: '#eeeeee', // to debug legend
                },
                exporting: { enabled: false },
                chart: {
                    renderTo: chartContainer.getAttribute('id'),
                    type: 'pie',
                    // backgroundColor: '#000000', // to debug chart
                    plotBackgroundImage: null,
                    margin: [0, 0, 0, 0],
                    spacingTop: 50,
                    spacingBottom: 0,
                    spacingLeft: 0,
                    spacingRight: 0,
                    height: chartHeight, // height of whole chart, should be dynamic of item counts
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: null
                },
                yAxis: {
                    title: {
                        text: 'Total percent market share'
                    }
                },
                plotOptions: {
                    pie: {
                        shadow: false,
                        size: $ctrl.size, //  size of pie move top or left 50%
                        center: plotCenter
                    },

                    showInLegend: true
                },
                tooltip: {
                    formatter: function () {
                        return this.point.name + ': ' + Highcharts.numberFormat(this.point.y, 1, decimalPoint, thousandsSep) + ' %';
                    },
                    style: {
                        color: "inherit",
                        fontSize: "14px",
                    }
                },
                series: [{
                    name: 'Browsers',
                    data: chartData,
                    innerSize: '80%',
                    showInLegend: true,
                    dataLabels: {
                        enabled: false
                    }
                }]
            });
        }
    }
};
chartPie.init();


function showMap() {
    $('.cookie-maps').attr('src', $('.cookie-maps').attr('maps-src'));
    $('.cookie-maps').parent().show();
    $('.cookie-maps').parent().next().hide();
}

function hideMap() {
    $('.cookie-maps').attr('maps-src', $('.cookie-maps').attr('src'));
    $('.cookie-maps').parent().hide();
    $('.cookie-maps').parent().next().show();
}


function weCookieConsentChecking() {
    var iframe = document.getElementsByTagName('iframe');
    if (iframe.length) {
        if (!getCookie('klaro')) {
            hideMap();
        } else {
            console.log(JSON.parse(decodeURIComponent(getCookie('klaro'))));
            if (!JSON.parse(decodeURIComponent(getCookie('klaro')))['other-3']) {
                hideMap();
            } else {
                showMap();
            }
        }
    }
}

if (typeof window !== 'undefined') {
    window.__weCookieConsentCheckingImpl = weCookieConsentChecking;
    window.weCookieConsentChecking = weCookieConsentChecking;
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
